import { Component, ElementRef, Input, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Series } from "../_models/series";
import { MapService } from "../_services/map/map.service";
import { NgxSpinnerService } from "ngx-spinner";
import { GridElementDetails } from "../_models/grid-element-details";
import { Config } from "../config";
import { NumberUtils } from "../_commons/number-utils";
import { Condition } from "../_models/condition";
import { ApplicationService } from "../_services/application/application.service";
import * as Highcharts from "highcharts";
import { HighchartsChartComponent } from "highcharts-angular";
import { ReactivePowerAnalysis, RpaConnectedNodes } from "../_models/reactive-power-analysis";
import { IntervalResults } from "../_models/interval-results";
import { ViolationResults } from "../_models/violation-results";
import { GridColor } from "../_models/grid-color";
import { GMonService } from "../_services/gmon-service/gmon.service";
import { LaService } from "../_services/la-service/la.service";
import {
  ReactivePowerAnalysisService
} from "../_services/reactive-power-analysis-service/reactive-power-analysis.service";
import { GPlanService } from "../_services/gplan-service/gplan.service";
import { GridElementService } from "../_services/grid-element/grid-element.service";
import { LoadingAnalysisData } from "../_models/loading-analysis-data";
import { ConfigurationService } from "../_services/configuration/configuration.service";
import { TranslateService } from "@ngx-translate/core";
import { DateUtils } from "../_commons/date-utils";
import { UIUtils } from "../_commons/ui-utils";
import { GPlanInput } from "../_models/gplan-input";
import { FormControl, FormGroup } from "@angular/forms";
import { HomeComponent } from "../home/home.component";
import { HttpClient } from '@angular/common/http';
import { LmService } from "../_services/lm-service/lm.service";
import { ThdMonitoringService } from "../_services/thd-monitoring-service/thd-monitoring.service";
import { CommunicationService } from '../_services/communication-service/communication.service';
import HC_more from 'highcharts/highcharts-more';
import { start } from "repl";
import { catchError } from "rxjs/operators";
import { ConnectedNodesActiveAndReactivePower } from "../_models/rpa-processing-result";
import { HighlightSpanKind } from 'typescript';
import { cachedDataVersionTag } from 'v8';
import { TopologyList, TopologyWithRoot } from '../_models/topology-list';
HC_more(Highcharts);

@Component({
  selector: "app-node-dialog-details",
  templateUrl: "./node-details-dialog.component.html",
  styleUrls: ["./node-details-dialog.component.css"],
})
export class NodeDetailsDialogComponent implements OnInit, AfterViewInit {
  @Input() public gridElementId: number;
  @Input() public elementType: string;
  @Input() public selectedPlanningScenario: boolean;
  @Input() public selectedScenario: GPlanInput;
  @Input() public jumpTopology: string;
  @Input() public noResult: boolean;

  Highcharts: typeof Highcharts = Highcharts;

  @ViewChild("gmonTimeViewChart", {static: false})
  public gmonTimeViewChart: HighchartsChartComponent;

  @ViewChild("frequencyDetailsViewChart", {static: false})
  public frequencyDetailsViewChart: HighchartsChartComponent;

  @ViewChild("frequencySummaryViewChart", {static: false})
  public frequencySummaryViewChart: HighchartsChartComponent;

  @ViewChild("nodeLoadingChart", {static: false})
  public nodeLoadingChart: HighchartsChartComponent;

  @ViewChild("reactivePowerAnalysisChart", {static: false})
  public reactivePowerAnalysisChart: HighchartsChartComponent;

  @ViewChild("reactivePowerViolationsChart", {static: false})
  public reactivePowerViolationsChart: HighchartsChartComponent;

  @ViewChild("gplanGmonTimeViewChart", {static: false})
  public gplanGmonTimeViewChart: HighchartsChartComponent;

  @ViewChild("gplanLATimeViewChart", {static: false})
  public gplanLATimeViewChart: HighchartsChartComponent;

  @ViewChild("livePowerData", {static: false})
  public livePowerDataChart: HighchartsChartComponent;

  @ViewChild("liveVoltageData", {static: false})
  public liveVoltageDataChart: HighchartsChartComponent;

  @ViewChild("thdMonitoringResultsChart", {static: false})
  public thdMonitoringResultsChart: HighchartsChartComponent;

  @ViewChild("connectedNodesActivePowerChart", {static: false})
  public connectedNodesActivePowerChart: HighchartsChartComponent;

  @ViewChild("connectedNodesReactivePowerChart", {static: false})
  public connectedNodesReactivePowerChart: HighchartsChartComponent;

  @ViewChild('LivePowerTabRef', {static: false}) livePowerTabRef!: ElementRef;

  gmonAvailable: boolean = false;
  laAvailable: boolean = false;
  lcAvailable: boolean = false;
  gplanAvailable: boolean = false;
  rpaAvailable: boolean = false;
  lmResultVisualizationInterval:number = 5;
  lmResultsRefreshPeriodInSeconds:number = 180;
  public worstCase: boolean = false;
  public gridElementIconUrl: string = "";
  public isGMonTimeChartEmpty: boolean = false;
  isThdMonitoringReceived: boolean = false;

  public isFrequencyTimeChartEmpty: boolean = false;

  public screenWidth: number;

  gmonGridNodeInfo: Array<any> = new Array<any>();
  gridElementName: string = "";
  rootNodeName: string;

  isDangerVoltage = false;
  isDangerVoltageGP = false;
  isAttentionVoltage = false;
  isAttentionVoltageGP = false;
  isDangerLA = false;
  isDangerLAGP = false;
  isAttentionLA = false;
  isAttentionLAGP = false;
  isDangerRPA = false;
  isAttentionRPA = false;
  isAttentionFrequency = false;
  isDangerFrequency = false;

  gmonDataAvailable = false;
  gmonDataAvailableGP = false;
  frequencyDataAvailable = false;
  laDataAvailable = false;
  laDataAvailableGP = false;
  gplanDataAvailable = false;
  rpaDataAvailable = false;

  //  reactivePowerOutput: boolean;
  areRPADataNull: boolean = false;
  areRPVDataNull: boolean = false;
  rpvTextUp: string;
  rpvTextDown: string;

  isGPlanGmonChartEmpty: boolean = false;
  //isCurrentTab: boolean = false;


  public isInputFieldForLiveMonitoringComponentShown: boolean = false;
  public intervalForLiveMonitoringLineGraphInMinutes: number;

  isNotTrafo = true;
  showFrequency = true;

  gmonTimeViewOptions: Highcharts.Options;
  nodeLoadingOptions: Highcharts.Options;
  gplanGmonTimeViewOptions: Highcharts.Options;
  frequencyDetailsViewOptions: Highcharts.Options;
  frequencySummaryViewOptions: Highcharts.Options;
  reactivePowerAnalysisOptions: Highcharts.Options;
  reactivePowerViolationsOptions: Highcharts.Options;
  gplanLATimeViewOptions: Highcharts.Options;
  livePowerDataOptions: Highcharts.Options;
  liveVoltageDataOptions: Highcharts.Options;
  thdMonitoringOptions: Highcharts.Options;
  connectedNodesActivePowerOptions: Highcharts.Options;
  connectedNodesReactivePowerOptions: Highcharts.Options;
  testingData: Array<number> = new Array<number>();
  stoppingBoolean: boolean = true
  chechingIsOnRightTabVariable: boolean = true;

  timestampArray: Array<any> = new Array<any>();
  valueLoad: Array<number> = new Array<number>();
  valueVoltage: Array<number> = new Array<number>();

  intervalVariable;

  translations: any;

  labelLowerTenPercentQuantiles: string = "";
  labelUpperTenPercentQuantiles: string = "";
  labelVoltage: string = "";
  labelFrequency: string = "";
  labelMinimum: string = "";
  labelMaximum: string = "";
  labelAverage: string = "";
  labelViolations: string = "";
  labelActivePower: string = "";
  labelReactivePower: string = "";
  labelLoad: string = "";
  labelWorstCaseLoading: string = "";
  labelDay: string = "";
  labelNight: string = "";
  labelInductiveViolationArea: string = "";
  labelCapacitiveViolationArea: string = "";
  labelPlanningLoad: string = "";
  labelWorstCaseLoad: string = "";
  labelPlanningLowerTenPercentQuantiles: string = "";
  labelPlanningUpperTenPercentQuantiles: string = "";
  labelPlanningVoltage: string = "";
  labelWorstCaseVoltage: string = "";
  labelNoInductiveViolations: string = "";
  labelInductiveViolations: string = "";
  labelDays: string = "";
  labelNights: string = "";
  labelNoCapacitiveViolations: string = "";
  labelCapacitiveViolations: string = "";
  thdMonitoringChartSeriesLegend: string = "";
  isRoot: boolean = false;
  rootId: number;
  isGenerator: boolean = false;
  timestampTitleForConnectedNodesActiveAndReactivePowerCharts: string = "";
  activePowerUnitForConnectedNodesActivePowerChart: string = "";
  reactivePowerUnitForConnectedNodesReactivePowerChart: string = "";
  reactivePowerSwitchActivationLabel: string = "";
  reactivePowerSwitchDeactivationLabel: string = "";

  private showGmon: boolean;
  private gMonOutputData: any;


  private homeComponent: HomeComponent;
  public isLivePowerDataShown: boolean;

  //Forecase map that stores timestamp and source
  public forecastDataMap: Array<string> = new Array<string>();
  public forecastLaDataMap: Array<string> = new Array<string>();
  public forecastLaPlanningDataMap: Array<string> = new Array<string>();
  public forecastGmonDataMap: Array<string> = new Array<string>();
  public forecastGmonPlanningDataMap: Array<string> = new Array<string>();

  updateVoltageTimeViewFlag = false;
  updateNodeLoadingChartFalse= false;
  updateReadtivePowerAnalysisChartFlag = false;
  updateReactivePowerViolationsChartFlag = false;
  updateGplanGmonTimeViewChartFlag= false;
  updateGplanLATimeViewChartFlag = false;
  updateConnectedNodesActivePowerChartFlag = false;
  updateConnectedNodesActivePowerTabFlag = false;
  updateConnectedNodesReactivePowerChartFlag = false;
  updateConnectedNodesReactivePowerTabFlag = false;
  updateLiveVoltageDataViewFlag = false;
  updateLivePowerDataViewFlag = false;
  chartInstance!: Highcharts.Chart;
  connectedNodesActiveAndReactivePower: Array<RpaConnectedNodes> = new Array<RpaConnectedNodes>();
  // activeTab: string = 'gmon-time-view';
  private chart?: Highcharts.Chart;

  chartCallBack = (chart: Highcharts.Chart) => { this.chart = chart}
  onChartInstance(chart: Highcharts.Chart) {this.chartInstance = chart}

  //reative power chart
  reactivePowerToggleLabel: any;
  reactivePowerToggleTrack: any;
  reactivePowerToggleKnob: any;

  //Variable to store topology Display name if the jumpTopology variable exists
  public topologyToJumpDisplayName: string;

  constructor(
    private spinner: NgxSpinnerService,
    public activeModal: NgbActiveModal,
    private mapService: MapService,
    private applicationService: ApplicationService,
    private gMonService: GMonService,
    private gPlanService: GPlanService,
    private laService: LaService,
    private gridElementService: GridElementService,
    private reactivePowerAnalysisService: ReactivePowerAnalysisService,
    public translateService: TranslateService,
    private configurationService: ConfigurationService,
    private http: HttpClient,
    private lmService: LmService,
    private thdMonitoringService: ThdMonitoringService,
    private communicationService: CommunicationService
  ) {

    const applications: any = this.configurationService.getConfiguration().APPLICATIONS;
    this.gmonAvailable = applications.gmonAvailable;
    this.laAvailable = applications.laAvailable;
    this.lcAvailable = applications.lcAvailable;
    this.gplanAvailable = applications.gplanAvailable;
    this.rpaAvailable = applications.rpaAvailable;
    this.lmResultVisualizationInterval = this.configurationService.getConfiguration().lmResultVisualizationInterval;
    this.lmResultsRefreshPeriodInSeconds = this.configurationService.getConfiguration().lmResultsRefreshPeriodInSeconds;

    this.isLivePowerDataShown = this.configurationService.getConfiguration().APPLICATIONS.isLiveMonitoringAndControlComponentShown;
    this.isInputFieldForLiveMonitoringComponentShown = this.configurationService.getConfiguration().APPLICATIONS.configurationForInputFieldInLiveMonitoringComponent;
    this.intervalForLiveMonitoringLineGraphInMinutes = this.configurationService.getConfiguration().intervalForLiveMonitoringLineGraphInMinutes;

    this.gmonTimeViewOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          // scaleBreaks: {
          //   autoCalculate: true,
          // },
          title: {
            text: "",
          },
          endOnTick: true,
          plotLines: [
            {
              color: "#FF0000",  //red
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
            },
            {
              color: "#FF0000",   //red
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false,
      },
    };

    this.frequencyDetailsViewOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          // scaleBreaks: {
          //   autoCalculate: true,
          // },
          title: {
            text: "",
          },
          endOnTick: true,
          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false,
      },
    };

    this.frequencySummaryViewOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "column",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        },
        styledMode: true,
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      series: [],
      xAxis: {
        categories: [""],
        /*title: {
                      text: 'No Dates'
                    }*/
      },
      yAxis: [
        {
          min: 0,
          // scaleBreaks: {
          //   autoCalculate: true,
          // },
          title: {
            text: "",
          },
          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: "",
          },
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        series: {
          stickyTracking: true,
          // whiskerWidth: 5,
        },
      },
      credits: {
        enabled: false,
      },
    };

    this.nodeLoadingOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          title: {
            text: "",
          },
          max: 120,
          endOnTick: false,
          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false,
      },
    };


    const nodeDetailsDialogComponent = this;

    this.reactivePowerAnalysisOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        },
        events: {
          load: function () {
            const chart = this as any;

            nodeDetailsDialogComponent.reactivePowerAnalysisChart = chart;

            chart.handlePointClick = (point: any) => {
              nodeDetailsDialogComponent.onReactivePowerAnalysisPointClicked(point);
            }

            chart.isSwitchOn = false;

            const x = 10;
            const y = 10;

            const track = chart.renderer
              .rect(x, y, 50, 20, 10)
              .attr({ fill: '#ccc' })
              .css({ cursor: 'pointer' })
              .add();

            const knob = chart.renderer
              .circle(x + 10, y + 10, 8)
              .attr({ fill: '#fff' })
              .css({ cursor: 'pointer' })
              .add();

            const label = chart.renderer
              .text("", x + 60, y + 15)
              .css({
                fontSize: '12px',
                cursor: 'pointer'
              })
              .add();

            nodeDetailsDialogComponent.reactivePowerToggleTrack = track;
            nodeDetailsDialogComponent.reactivePowerToggleKnob = knob;
            nodeDetailsDialogComponent.reactivePowerToggleLabel = label;

            label.attr({
                text: nodeDetailsDialogComponent.reactivePowerSwitchDeactivationLabel || ""
              });

            const toggle = () => {
              chart.isSwitchOn = !chart.isSwitchOn;

              knob.animate({
                cx: chart.isSwitchOn ? x + 40 : x + 10
              }, { duration: 200 });

              track.attr({
                fill: chart.isSwitchOn ? '#28a745' : '#ccc'
              });

              label.attr({
                text: chart.isSwitchOn ? nodeDetailsDialogComponent.reactivePowerSwitchActivationLabel : nodeDetailsDialogComponent.reactivePowerSwitchDeactivationLabel
              });
            };

            track.on('click', toggle);
            knob.on('click', toggle);
            label.on('click', toggle);

            chart.customToggleLabel = label;
          }
        }
      },
      xAxis: {
        // type: 'datetime',
        // alignTicks: false,
        labels: {
          formatter: function () {
            // console.log("What is this: ", this.value);
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          },
          // step: 5,
          // format: "{value:%Y-%m-%d %H:%M}",
        },
        // step: 5,
        categories: [],
        title: {
          text: "",
        },
        startOnTick: true,
      },
      yAxis: [
        {
          title: {
            text: "",
          },
          allowDecimals: false,
          plotLines: [],
          // labels: Config.chartYAxisLabelFormatterKilo,
        },
        {
          opposite: false,
          allowDecimals: false,
          title: {
            text: "",
          },
          //  labels: Config.chartYAxisLabelFormatterKilo,
        },
      ],
      legend: { layout: "horizontal", align: "center" },
      plotOptions: {
        line: Config.chartLine,
        series: {
          point:{
            events: {
              click: function(){
                const chart = this.series.chart as any;

                if(chart.isSwitchOn && chart.handlePointClick){
                  chart.handlePointClick(this);
                }
              }
            }
          }
        }
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false,
      },
    };

    this.reactivePowerViolationsOptions = {
      title: {
        text: "",
      },
      /* subtitle: {
                      text: ''
                  }, */
      xAxis: {
        // className: 'highcharts-color-0',
        gridLineWidth: 1,
        title: {
          text: "",
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true,
        plotLines: [
          {
            color: "black",
            width: 2,
            dashStyle: "Solid",
            value: 0,
          },
        ],
      },
      yAxis: {
        title: {
          text: "",
        },
        endOnTick: false,
        plotLines: [
          {
            color: "black",
            width: 2,
            dashStyle: "Solid",
            value: 0,
          },
        ],
      },
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle",
      },
      series: [],
      tooltip: {
        headerFormat: "<b>{series.name}</b><br>",
        // pointFormat: '{point.x} , {point.y} '
      },
      credits: {
        enabled: false,
      },
      chart: {
        width: UIUtils.calculateWidth(window, Config.RPV_CHART_WIDTH_PERCENTAGE)
      }
    };

    this.gplanGmonTimeViewOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          // scaleBreaks: {
          //   autoCalculate: true,
          // },
          title: {
            text: "",
          },
          endOnTick: true,
          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false,
      },
    };

    this.gplanLATimeViewOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          // scaleBreaks: {
          //   autoCalculate: true,
          // },
          title: {
            text: "",
          },
          endOnTick: false,
          plotLines: [
            {
              color: "#FF0000",
              width: 1,
              dashStyle: "ShortDash",
              value: 0,
              zIndex: 3
            },
          ],
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this)
        }
      },
      credits: {
        enabled: false,
      },
    };

    this.thdMonitoringOptions = {
      title: {
        text: "",
      },
      series: [],
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        type: "line",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      xAxis: {
        labels: {
          formatter: function () {
            return DateUtils.stringUTCDateToLocalDate(this.value.toString());
          }
        },
        categories: [],
        title: {
          text: "",
        },
      },
      yAxis: [
        {
          min: 0,
          // scaleBreaks: {
          //   autoCalculate: true,
          // },
          title: {
            text: "THD [%]",
          },
          endOnTick: true,
        }
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        line: Config.chartLine,
      },
      tooltip: {
        formatter: function () {
          return Config.formatTooltip(this);
        }
      },
      credits: {
        enabled: false,
      }
    };

    this.connectedNodesActivePowerOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        height: UIUtils.calculateHeight(window, Config.CHART_HEIGHT_PERCENTAGE),
        type: "column",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: 0
          }
        }
      },
      title: {
        text: "",
      },
      subtitle: {
        text: ""
      },
      series: [],
      xAxis: {
        categories: [],
        title: {
          text: ""
        },
        labels: {
          style: {
            whiteSpace: 'nowrap'
          },
          rotation: -45
        }
      },
      yAxis: [
        {
          // Removed scaleBreaks as it is not a valid property

          title: {
            text: "",
          },
          plotLines: [
          ],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: "",
          },
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        series: {
          stickyTracking: true
        }
      },
      credits: {
        enabled: false
      }
    };

    this.connectedNodesReactivePowerOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.CHART_WIDTH_PERCENTAGE),
        height: UIUtils.calculateHeight(window, Config.CHART_HEIGHT_PERCENTAGE),
        type: "column",
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: 0
          }
        }
      },
      title: {
        text: "",
      },
      subtitle: {
        text: ""
      },
      series: [],
      xAxis: {
        categories: [],
        title: {
          text: ""
        },
        labels: {
          style: {
            whiteSpace: 'nowrap'
          },
          rotation: -45
        }
      },
      yAxis: [
        {
          // Removed scaleBreaks as it is not a valid property

          title: {
            text: "",
          },
          plotLines: [
          ],
        },
        {
          opposite: true,
          allowDecimals: false,
          title: {
            text: "",
          },
        },
      ],
      legend: {
        layout: "horizontal",
        align: "center",
      },
      plotOptions: {
        series: {
          stickyTracking: true
        }
      },
      credits: {
        enabled: false
      }
    }

    // Translations
    const language = localStorage.getItem("Language");

    translateService.getTranslation(language).subscribe((translations) => {
      console.log("Translations: ", translations);

      this.translations = translations;

      this.gmonTimeViewOptions.title.text = translations.nodedetailsdialog["b787b706-6468-477d-a0e8-a2e730437721"];

      if(!Array.isArray(this.gmonTimeViewOptions.xAxis)){
        this.gmonTimeViewOptions.xAxis.title.text= translations["code-string"]["Time-intervals"];
      }
      // this.gmonTimeViewOptions.xAxis[0].title.text = translations["code-string"]["Time-intervals"];
      this.gmonTimeViewOptions.yAxis[0].title.text = translations["code-string"].Voltages + " [V]";

      this.frequencyDetailsViewOptions.title.text = translations["code-string"].Frequency;
      if(!Array.isArray(this.frequencyDetailsViewOptions.xAxis)){
        this.frequencyDetailsViewOptions.xAxis.title.text = translations["code-string"]["Time-intervals"];
      }
      this.frequencyDetailsViewOptions.yAxis[0].title.text = translations["code-string"].Frequency + " [Hz]";

      this.frequencySummaryViewOptions.title.text = translations["code-string"].Frequency;
      this.frequencySummaryViewOptions.subtitle.text = translations["code-string"]["No-Dates"];
      this.frequencySummaryViewOptions.yAxis[0].title.text = translations["code-string"].Frequency + " [Hz]";
      this.frequencySummaryViewOptions.yAxis[1].title.text = translations["code-string"].Violations;

      this.nodeLoadingOptions.title.text = translations["code-string"]["Node-Loading"];
      if(!Array.isArray(this.nodeLoadingOptions.xAxis)){
        this.nodeLoadingOptions.xAxis.title.text = translations["code-string"]["Time-intervals"];
      }
      this.nodeLoadingOptions.yAxis[0].title.text = translations["code-string"]["Loading-Apparent-Power"];

      this.reactivePowerAnalysisOptions.title.text = translations["code-string"]["Active-and-Reactive-Power"];
      if(!Array.isArray(this.reactivePowerAnalysisOptions.xAxis)){
        this.reactivePowerAnalysisOptions.xAxis.title.text = translations["code-string"]["Time-intervals"];
      }

      this.reactivePowerViolationsOptions.title.text = translations["code-string"]["Violations"];
      this.gplanGmonTimeViewOptions.title.text = translations["code-string"]["Voltage-Pre-and-Post-Planning"];
      if(!Array.isArray(this.gplanGmonTimeViewOptions.xAxis)){
        this.gplanGmonTimeViewOptions.xAxis.title.text = translations["code-string"]["Time-intervals"];
      }
      this.gplanGmonTimeViewOptions.yAxis[0].title.text = translations["code-string"].Voltages + " [V]";

      this.gplanLATimeViewOptions.title.text = translations["code-string"]["Node-Loading-Pre-and-Post-Planning"];
      if(!Array.isArray(this.gplanLATimeViewOptions.xAxis)){
        this.gplanLATimeViewOptions.xAxis.title.text = translations["code-string"]["Time-intervals"];
      }
      this.gplanLATimeViewOptions.yAxis[0].title.text = translations["code-string"]["Loading-Apparent-Power"];

      this.labelLowerTenPercentQuantiles = translations["code-string"]["Lower-ten-percent-quantiles"];
      this.labelUpperTenPercentQuantiles = translations["code-string"]["Upper-ten-percent-quantiles"];
      this.labelVoltage = translations["code-string"].Voltage;
      this.labelFrequency = translations["code-string"].Frequency;
      this.labelMinimum = translations["code-string"].Minimum;
      this.labelMaximum = translations["code-string"].Maximum;
      this.labelAverage = translations["code-string"].Average;
      this.labelViolations = translations["code-string"].Violations;
      this.labelActivePower = translations["code-string"]["Active-Power"];
      this.labelReactivePower = translations["code-string"]["Reactive-Power"];
      this.labelLoad = translations["code-string"].Load;
      this.labelWorstCaseLoading = translations["code-string"]["Worst-Case-Loading"]
      this.labelDay = translations["code-string"].Day;
      this.labelNight = translations["code-string"].Night;
      this.labelInductiveViolationArea = translations["code-string"]["Inductive-violation-area"];
      this.labelCapacitiveViolationArea = translations["code-string"]["Capacitive-violation-area"];
      this.labelPlanningLoad = translations["code-string"]["Planning-Load"];
      this.labelWorstCaseLoad = translations["code-string"]["Worst-Case-Load"];

      this.labelPlanningLowerTenPercentQuantiles = translations["code-string"]["Planning-Lower-ten-percent-quantiles"];
      this.labelPlanningUpperTenPercentQuantiles = translations["code-string"]["Planning-Upper-ten-percent-quantiles"];
      this.labelPlanningVoltage = translations["code-string"]["Planning-Voltage"];
      this.labelWorstCaseVoltage = translations["code-string"]["Worst-Case-Voltage"];

      this.labelNoInductiveViolations = translations["code-string"]["No-inductive-violations"];
      this.labelInductiveViolations = translations["code-string"]["inductive-violations"];
      this.labelDays = translations["code-string"].days;
      this.labelNights = translations["code-string"].nights;
      this.labelNoCapacitiveViolations = translations["code-string"]["No-capacitive-violations"];
      this.labelCapacitiveViolations = translations["code-string"]["capacitive-violations"];

      if (!Array.isArray(this.thdMonitoringOptions.xAxis)) {
        this.thdMonitoringOptions.xAxis.title.text = translations.nodedetailsdialog["44cce86b-9478-487d-8853-ba9c47f160a3"];
      } else if (this.thdMonitoringOptions.xAxis.length > 0) {
        this.thdMonitoringOptions.xAxis[0].title.text = translations.nodedetailsdialog["44cce86b-9478-487d-8853-ba9c47f160a3"];
      }

      this.connectedNodesReactivePowerOptions.title.text = translations.nodedetailsdialog["aa03a551-72ea-486a-b093-07bb8832428b"];
      this.connectedNodesActivePowerOptions.title.text = translations.nodedetailsdialog["636951ae-befc-4518-bac2-030f8d12633b"];

      //Assigning Translations for switch in Reactive Power Analysis Chart
      this.reactivePowerSwitchActivationLabel = translations.nodedetailsdialog["077453f9-0ab1-4c26-a199-75fa0b224af9"];
      this.reactivePowerSwitchDeactivationLabel = translations.nodedetailsdialog["bd3b475c-7c37-49e4-b70e-a8ee1fd4a91d"];

      if (this.reactivePowerToggleLabel) {
        this.reactivePowerToggleLabel.attr({
          text: this.reactivePowerSwitchDeactivationLabel
        });
      }
    });
  }
  ngAfterViewInit(): void {
    const voltageTab = document.getElementById('voltage-tab');
    if(voltageTab){
      voltageTab.addEventListener('shown.bs.tab', () => {
        setTimeout(() => this.chart?.reflow(), 0);
      })
    }

    const tab = document.querySelector('#connected-nodes-active-power-tab');
    tab?.addEventListener('shown.bs.tab', () => {
      setTimeout(() => {
        this.connectedNodesActivePowerChart?.updateOrCreateChart();
      }, 0);
    });
  }

  ngOnInit(): void {
    this.screenWidth = UIUtils.calculateWidth(window, 75);
    this.isNotTrafo = !this.mapService.isTrafo(this.elementType);
    //this.isCurrentTab = this.doGPlanRunning();
    if (this.gmonAvailable) {
      this.initGmonData();
    }
    this.loadGridElementDetails();
    this.getGridNodeTabColor();

    this.rootNodeName = this.gridElementService.getRootNodeName();
    this.rootId = this.gridElementService.getRootNodeId();
    console.log("root-id = " + this.rootId + ", grid-element-Id = " + this.gridElementId);
    this.isRoot = this.rootId == this.gridElementId;
    // console.log("is-root? = " + this.isRoot);
    // console.log("is-data-ava? = " + this.rpaDataAvailable);
    // console.log("is-ava? = " + this.rpaAvailable);

    this.checkWorstCase();

    this.isThdMonitoringReceived = this.thdMonitoringService.getThdIsReceived();

    // Somehow noResult variable is undefined when the dialog is opened via the Structured view map
    if(this.noResult == undefined || this.noResult == null){
      this.noResult = false;
    }

    //Get topology display name to show on the component button
    this.getInternalDsoIdOfTopologyToJump();
  }


  settingIntervalForChart() {
    this.livePowerDataOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.RPV_CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      title: {
        text: 'Echtzeit Trafoauslastung'
      },
      xAxis: {
        labels: {
          formatter: function () {
            return this.value.toString();
          }
        },
        categories: []
      },
      yAxis: [
        {
          title: {
            text: " [%]"
          }
        }],
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        }
      },
      series: [
        {
          type: 'line',
          name: 'Trafoauslastung',
          data: []
        }
      ],
      credits: {
        enabled: false,
      }
    };

    this.liveVoltageDataOptions = {
      chart: {
        width: UIUtils.calculateWidth(window, Config.RPV_CHART_WIDTH_PERCENTAGE),
        type: 'line',
        zoomType: "xy",
        resetZoomButton: {
          position: {
            x: 0,
            y: -45
          }
        }
      },
      title: {
        text: 'Echtzeit Knotenspannung'
      },
      xAxis: {
        labels: {
          formatter: function () {
            return this.value.toString();
          }
        },
        categories: []
      },
      yAxis: [
        {
          title: {
            text: "[V]"
          }
        }],
      plotOptions: {
        line: {
          dataLabels: {
            enabled: false
          },
          enableMouseTracking: true
        }
      },
      series: [
        {
          type: 'line',
          name: 'Spannung',
          data: []
        }
      ],
      credits: {
        enabled: false,
      }
    };

    // console.log("IntervalWorks")
    // this.addValue(Math.round(Math.random()* 100));
    // this.livePowerDataOptions.series[0].data = this.testingData
    // this.livePowerDataOptions.series[0].data.push(Math.random()* 10);
    // this.livePowerDataOptions.series[0].data.push(Math.random()* 10);
    // console.log("PUSHING THIS DATA " + this.livePowerDataOptions.series[0].data)
    // this.livePowerDataChart.options = this.livePowerDataOptions
    // this.livePowerDataChart.redraw;
  }

  addValue(value: number): void {
    this.testingData.push(value)
  }

  loadGridElementDetails() {
    setTimeout(() => {

    });

    this.mapService.getGridElementDetails(this.gridElementId).subscribe(
      (gridElementDetails: GridElementDetails) => {
        console.log("griddetails: " + JSON.stringify(gridElementDetails));

        this.gridElementName = gridElementDetails.name;

        if (gridElementDetails.elementSubType == "Generator") {
          this.isGenerator = true;
        } else {
          this.isGenerator = false;
        }

        this.gmonGridNodeInfo.push({
          attribute: this.translations["code-string"].type,
          value: this.translations["code-string"][gridElementDetails.elementSubType],
        });

        this.gmonGridNodeInfo.push({
          attribute: this.translations["code-string"].name,
          value: gridElementDetails.name,
        });

        if (
          gridElementDetails.streetAddress != null &&
          gridElementDetails.streetAddress != "" &&
          gridElementDetails.streetAddress != "null, null"
        ) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["street-address"],
            value: gridElementDetails.streetAddress,
          });
        }

        if (
          gridElementDetails.parentNode != null &&
          gridElementDetails.parentNode != ""
        ) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["parent-node-name"],
            value: gridElementDetails.parentNode,
          });
        }

        if (
          gridElementDetails.totOutgoingCables != null &&
          gridElementDetails.totOutgoingCables != 0
        ) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["number-of-outgoing-cables"],
            value: gridElementDetails.totOutgoingCables
              .toFixed()
              .toLocaleString(),
          });
        }

        if (gridElementDetails.typeOfGenerator) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["Type-Of-Gererator"],
            value: gridElementDetails.typeOfGenerator,
          });
        }

        // if (gridElementDetails.elementSubType != Config.METER
        //  || gridElementDetails.elementSubType != Config.GENERATOR) {
        // if (gridElementDetails.elementSubType == Config.CCBOX
        //   || gridElementDetails.elementSubType == Config.TRANSFORMER
        //   || gridElementDetails.elementSubType == Config.JUNCTIONBOX
        //   || gridElementDetails.elementSubType == Config.SLEEVE) {

        if (
          gridElementDetails.maxConsumption != null &&
          gridElementDetails.maxConsumption != 0
        ) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["max-consumption"],
            value:
              NumberUtils.format1(
                gridElementDetails.maxConsumption,
                1
              ).toLocaleString() + " kW",
          });
        }

        if (
          gridElementDetails.maxGeneration != null &&
          gridElementDetails.maxGeneration != 0
        ) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["max-generation"],
            value:
              NumberUtils.format1(
                gridElementDetails.maxGeneration,
                2
              ).toLocaleString() + " kWp",
          });
        }
        // }
        // console.log('type0: ' + gridElementDetails.elementSubType);
        // if (gridElementDetails.elementSubType == Config.TRANSFORMER) {
        if (
          gridElementDetails.installedCapacity != null &&
          gridElementDetails.installedCapacity.length !== 0
        ) {
          // console.log('type: ' + gridElementDetails.elementSubType);
          const capacitiesStr = JSON.stringify(
            gridElementDetails.installedCapacity
          );
          const capacities = capacitiesStr.split(",");
          if (capacities.length > 1) {
            this.gmonGridNodeInfo.push({
              attribute: this.translations["code-string"]["Installed-Transformer-Capacities"],
              value: gridElementDetails.installedCapacity + " (kVA)",
            });
          } else if (capacities.length === 1) {
            this.gmonGridNodeInfo.push({
              attribute: this.translations["code-string"]["Installed-Capacity"],
              value:
                gridElementDetails.installedCapacity + " kVA",
            });
          }
        }

        if (gridElementDetails.trafoNominalPower) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["Trafo-Nominal-Power"],
            value:
              NumberUtils.format1(
                +gridElementDetails.trafoNominalPower,
                1
              ).toLocaleString() + " kW",
          });
        }

        if (gridElementDetails.connectedTrafoNominalPower) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["Connected-Trafo-Nominal-Power"],
            value:
              NumberUtils.format1(
                +gridElementDetails.connectedTrafoNominalPower,
                1
              ).toLocaleString() + " kVA",
          });
        }

        if (gridElementDetails.voltageLevel) {
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["Voltage-Level"],
            value:
              NumberUtils.format1(
                +gridElementDetails.voltageLevel,
                1
              ).toLocaleString() + " V",
          });
        }

        if(gridElementDetails.setpointVoltage){
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["setpointVoltage"],
            value: gridElementDetails.setpointVoltage
          });
        }

        if(gridElementDetails.setpointResistance){
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["setpointResistance"],
            value: gridElementDetails.setpointResistance
          });
        }

        if(gridElementDetails.setpointReactance){
          this.gmonGridNodeInfo.push({
            attribute: this.translations["code-string"]["setpointReactance"],
            value: gridElementDetails.setpointReactance
          });
        }

        // Load node icon
        this.gridElementIconUrl = this.mapService.getIconUrl(
          this.elementType,
          Condition.NORMAL
        );


      },
      (error) => {
        console.error(error);

      }
    );
  }

  form = new FormGroup({
    userHoursInput: new FormControl('')
  });

  submitButtonVoltageData() {
    this.applicationService.getLiveVoltageDataTrafo(this.gridElementId, this.lmResultVisualizationInterval).subscribe((response) => {
      // console.log("Whole 50000 responses: " + JSON.stringify(response))
      this.timestampArray.length = 0;
      this.liveView(response, true);
    })
    console.log("User Input: " + this.form.value.userHoursInput);
  }

  submitButtonLivePowerData() {
    this.applicationService.getLivePowerNodes(this.gridElementId, this.lmResultVisualizationInterval).subscribe((response) => {
      this.timestampArray.length = 0;
      this.liveView(response, false);
    })
    console.log("User Input: " + this.form.value.userHoursInput);
  }

  loadLiveVoltageData() {


    // const url = "http://localhost:4200/icg/v1/rest/liveMeasurement/rs2dg/getActiveAndReactivePower/287";
    this.applicationService.getLiveVoltageDataTrafo(this.gridElementId, this.lmResultVisualizationInterval).subscribe((firstResponse) => {
      console.log("First Live Voltage Data call: ", firstResponse);
      this.liveView(firstResponse, true);
    }, error => {
      console.error("Failed to Perform First call", error)
    })
    clearInterval(this.intervalVariable);

    this.intervalVariable = setInterval(() => {
      this.applicationService.getLiveVoltageDataTrafo(this.gridElementId, this.lmResultVisualizationInterval).subscribe(
        (response) => {
          console.log("API response: ", (response));
          this.liveView(response, true);
        },
        error => {
          console.error("API ERROR ", error)
        }
      )
    }, 1000 * this.lmResultsRefreshPeriodInSeconds)             //interval when call is performed
  }

  loadLivePowerData() {


    clearInterval(this.intervalVariable);

    this.applicationService.getLivePowerNodes(this.gridElementId, this.lmResultVisualizationInterval).subscribe((firstResponse) => {
      console.log("First Live Power Data call is performed: ", firstResponse);
      this.liveView(firstResponse, false);
    }, error => {
      console.error("Error occured, failed to perform the first call for Live Power Data", error)
    })
    this.intervalVariable = setInterval(() => {
      this.applicationService.getLivePowerNodes(this.gridElementId, this.lmResultVisualizationInterval).subscribe(
        (response) => {
          console.log("API response for Live Power Data", response);
          this.liveView(response, false);
          //computation for the graph
        },
        error => {
          console.error("Error occured, while performing call for Live Power Data", error)
        }
      )
    }, 1000 * this.lmResultsRefreshPeriodInSeconds)
  }

  public liveView(liveDataResponse: any, ifVoltage: boolean) {

    var timestamp: any;
    var value: any;

    liveDataResponse.reverse();

    liveDataResponse.forEach(element => {

      console.log(`Timestamp: ${element.timestamp}, Value: ${element.timestamp}`)

      timestamp = element.timestamp;
      value = element.value;

      if (this.timestampArray.slice(-1) != timestamp) {
        // console.log("SLICED TIMESTAMP ARRAY " + this.timestampArray[this.timestampArray.length - 1])
        this.settingIntervalForChart();
      }

      var justDifferenceInMinutes;

      if (this.timestampArray.length != 0) {
        console.log("Timestamp array elements last: " + DateUtils.stringUTCDateToLocalDateObject(this.timestampArray[this.timestampArray.length - 1]).getTime());
        console.log("Timestamp array elements first: " + DateUtils.stringUTCDateToLocalDateObject(timestamp).getTime());
        if (DateUtils.stringUTCDateToLocalDateObject(this.timestampArray[this.timestampArray.length - 1]).getTime() - DateUtils.stringUTCDateToLocalDateObject(timestamp).getTime() != -(this.intervalForLiveMonitoringLineGraphInMinutes * 60000)) {
          var lastWrongElementsFromTimestampArray = this.timestampArray[this.timestampArray.length - 1]
          console.log("lastWrongElementsFromTimestampArray " + lastWrongElementsFromTimestampArray)
          var timestampArrayTentative: Array<any> = new Array<any>();

          for (var i = 1; i < (DateUtils.stringUTCDateToLocalDateObject(timestamp).getTime() - DateUtils.stringUTCDateToLocalDateObject(this.timestampArray[this.timestampArray.length - 1]).getTime()) / (60000 * this.intervalForLiveMonitoringLineGraphInMinutes); i++) {
            justDifferenceInMinutes = DateUtils.stringUTCDateToLocalDateObject(this.timestampArray[this.timestampArray.length - 1]).getMinutes();
            // console.log(lastWrongElementsFromTimestampArray)
            console.log(DateUtils.stringUTCDateToLocalDateObject(lastWrongElementsFromTimestampArray).getMinutes() + i)

            console.log(DateUtils.dateToString3(new Date(new Date(lastWrongElementsFromTimestampArray).setMinutes(justDifferenceInMinutes + i))));
            timestampArrayTentative.push(DateUtils.dateToString3(new Date(new Date(lastWrongElementsFromTimestampArray).setMinutes(justDifferenceInMinutes + i))));

            if (ifVoltage) {
              if (!this.valueVoltage.includes(undefined)) {
                this.valueVoltage.push(null);
              }
            } else {
              if (!this.valueLoad.includes(undefined)) {
                this.valueLoad.push(null);
              }
            }
          }
          this.timestampArray.push.apply(this.timestampArray, timestampArrayTentative)
        }
      }

      if (!this.timestampArray.includes(timestamp)) {
        this.timestampArray.push(timestamp);

        if (ifVoltage)
          this.valueVoltage.push(value);
        else
          this.valueLoad.push(value);
      } else {
        console.log("Array already contains this information")
      }
    })

    //console.log("TIMESTAMP " + timestamp + " timestamp array" + this.timestampArray.slice(-1) )

    if (ifVoltage)
      console.log("LIVE VALUE Voltage ARRAY " + this.valueVoltage)
    else
      console.log("LIVE VALUE Load ARRAY " + this.valueLoad)
    console.log("LIVE timestamps  " + this.timestampArray)

    if (ifVoltage && this.liveVoltageDataOptions != undefined) {
      (this.liveVoltageDataOptions.series[0] as Highcharts.SeriesLineOptions).data = this.valueVoltage;
      (this.liveVoltageDataOptions.xAxis as Highcharts.XAxisOptions).categories = this.timestampArray.map(timestamp => {
        if (timestamp && !isNaN(Date.parse(timestamp))) {
          return DateUtils.stringUTCDateToLocalDate(timestamp);
        }
        return null; // Return the original value if it is not valid
      });
    } else if (!ifVoltage && this.livePowerDataOptions != undefined) {
      (this.livePowerDataOptions.series[0] as Highcharts.SeriesLineOptions).data = this.valueLoad;
      (this.livePowerDataOptions.xAxis as Highcharts.XAxisOptions).categories = this.timestampArray.map(timestamp => {
        if (timestamp && !isNaN(Date.parse(timestamp))) {
          return DateUtils.stringUTCDateToLocalDate(timestamp);
        }
        return null; // Return the original value if it is not valid
      });
      ;
    }

    this.updateLiveVoltageDataViewFlag = true;
    this.updateLivePowerDataViewFlag = true;
  }


  loadVoltageTimeView() {
    setTimeout(() => {

    });
    this.isGMonTimeChartEmpty = false;
    // console.log(this.gMonOutputData.series)
    if (this.gMonOutputData) {
      this.voltageTimeView(this.gMonOutputData);
    } else {
      this.applicationService.getGmonTimeView(this.gridElementId).subscribe(
        (gmonResults: string) => {
          if (!gmonResults || gmonResults.length === 0) {
            console.log("gmon-data: " + this.isGMonTimeChartEmpty);
            this.isGMonTimeChartEmpty = true;

            return;
          }
          const gMonOutputData = JSON.parse(gmonResults);
          console.log("gMonOutputData : " + JSON.stringify(gMonOutputData));
          this.voltageTimeView(gMonOutputData);
        },
        (error) => {
          this.isGMonTimeChartEmpty = true;
          console.error(error);

        }
      );
    }

    clearInterval(this.intervalVariable);
  }

  voltageTimeView(gMonOutputData: any) {
    if (gMonOutputData.voltageResult == null) {
      this.isGMonTimeChartEmpty = true;

      return;
    }
    const tooltipV = Config.getChartTooltip("V")
    const xAxisCategories: Map<string, string> = new Map<string, string>();
    const series: Array<Series> = new Array<Series>();

    // const lowerValue: number = 0;
    // const upperValue: number = 0;
    // const allValues: Array<number> = new Array<number>();

    const lvData: Array<number> = new Array<number>();
    if (gMonOutputData.voltageResult.lowerQuantile) {
      gMonOutputData.voltageResult.lowerQuantile.forEach((value) => {
        const timestamp = value.timestamp;
        xAxisCategories.set(timestamp, timestamp);

        let valueTemp = null;
        if (value.value != null) {
          valueTemp = parseFloat(NumberUtils.format1(value.value, 2));
        }

        lvData.push(valueTemp);
        // allValues.push(valueTemp);
      });
    }

    if (lvData.length > 0) {
      const lvSeries: Series = new Series(this.labelLowerTenPercentQuantiles, lvData);
      lvSeries.tooltip = tooltipV;
      lvSeries.color = "#C0FE76";        //bright green
      series.push(lvSeries);
    }


    const uvData: Array<number> = new Array<number>();
    if (gMonOutputData.voltageResult.upperQuantile) {
      gMonOutputData.voltageResult.upperQuantile.forEach((value) => {
        const timestamp = value.timestamp;
        xAxisCategories.set(timestamp, timestamp);
        let valueTemp = null;
        if (value.value != null) {
          valueTemp = parseFloat(NumberUtils.format1(value.value, 2));
        }

        uvData.push(valueTemp);
        // allValues.push(valueTemp);
      });
    }
    if (uvData.length > 0) {
      const uvSeries: Series = new Series(this.labelUpperTenPercentQuantiles, uvData);
      uvSeries.tooltip = tooltipV;
      uvSeries.color = "#C0FE76";         //bright green
      series.push(uvSeries);

    }
    let maximumValue = gMonOutputData.voltageResult.lowerViolationLimit;
    let minimumValue = gMonOutputData.voltageResult.upperViolationLimit;
    const mvData: Array<number> = new Array<number>();
    gMonOutputData.voltageResult.average.forEach((value) => {
      const timestamp = value.timestamp;
      xAxisCategories.set(timestamp, timestamp);
      if(value.source == "forecast"){
        this.forecastGmonDataMap.push(value.timestamp);
      }
      let valueTemp = null;
      if (value.value != null) {
        valueTemp = parseFloat(NumberUtils.format1(value.value, 2));
        if(valueTemp>maximumValue)
          maximumValue=valueTemp;
        if(valueTemp<minimumValue)
          minimumValue = valueTemp;
      }

      mvData.push(valueTemp);
      // allValues.push(valueTemp);
    });
    const mediumSeries: Series = new Series(this.labelVoltage, mvData);
    mediumSeries.tooltip = tooltipV;
    mediumSeries.color = "#85D9FF"; //light blue color
    series.push(mediumSeries);

    // console.log(JSON.stringify(series));

    xAxisCategories.forEach((key: string) => {
      if (!Array.isArray(this.gmonTimeViewOptions.xAxis)) {
        this.gmonTimeViewOptions.xAxis.categories.push(key);
      } else if (this.gmonTimeViewOptions.xAxis.length > 0) {
        this.gmonTimeViewOptions.xAxis[0].categories.push(key);
      }
    });
    if(this.forecastGmonDataMap.length > 0){
       if (!Array.isArray(this.gmonTimeViewOptions.xAxis)) {
         this.gmonTimeViewOptions.xAxis.plotBands = [{
           color: "#dddddd",
           from: this.gmonTimeViewOptions.xAxis.categories.indexOf(this.forecastGmonDataMap[0]) - 0.5,
           to: this.gmonTimeViewOptions.xAxis.categories.indexOf(this.forecastGmonDataMap[this.forecastGmonDataMap.length - 1]) + 0.5,
         }];
       } else if (this.gmonTimeViewOptions.xAxis.length > 0) {
         this.gmonTimeViewOptions.xAxis[0].plotBands = [{
           color: "#dddddd",
           from: this.gmonTimeViewOptions.xAxis[0].categories.indexOf(this.forecastGmonDataMap[0]) - 0.5,
           to: this.gmonTimeViewOptions.xAxis[0].categories.indexOf(this.forecastGmonDataMap[this.forecastGmonDataMap.length - 1]) + 0.5,
         }];
       }
    }
    // allValues.sort();
    // console.log(allValues);
     this.gmonTimeViewOptions.yAxis[0].min = minimumValue * 0.98;
          this.gmonTimeViewOptions.yAxis[0].max = maximumValue * 1.02;

    this.gmonTimeViewOptions.yAxis[0].plotLines[0].value =
      gMonOutputData.voltageResult.upperViolationLimit;
    this.gmonTimeViewOptions.yAxis[0].plotLines[1].value =
      gMonOutputData.voltageResult.lowerViolationLimit;

    this.gmonTimeViewOptions.series = JSON.parse(JSON.stringify(series));

    // console.log(JSON.stringify(this.gmonTimeViewOptions));
    // if (this.gmonTimeViewChart) {
    //   this.gmonTimeViewChart.options = this.gmonTimeViewOptions;
    // }
    console.log("gmon-data: " + this.isGMonTimeChartEmpty);
    this.updateVoltageTimeViewFlag = true;
  }

  loadNodeLoading(): void {
    setTimeout(() => {

    });
    //here
    this.applicationService.getLANodeData(this.gridElementId).subscribe(
      (laNodeLoadingResults: any) => {
        console.log("result: " + laNodeLoadingResults);
        if (!laNodeLoadingResults) {

          return;
        }
        const laNodeData: LoadingAnalysisData =
          JSON.parse(laNodeLoadingResults);

        const xAxisCategories: Map<string, string> = new Map<string, string>();
        const series: Array<Series> = new Array<Series>();
        let maximumValue = laNodeData.nodeViolationLimitPercent;

        // const allValues: Array<number> = new Array<number>();

        const loadData: Array<number> = new Array<number>();
        laNodeData.intervals.forEach((value) => {
          const timestamp = value.timestamp;
          xAxisCategories.set(timestamp, timestamp);
           if(value.source == "forecast"){
            this.forecastLaDataMap.push(value.timestamp);
            }
          let valueTemp = null;
          if (value.loadPercent != null) {
            valueTemp = parseFloat(NumberUtils.format1(value.loadPercent, 2));
            if(maximumValue < valueTemp)
              maximumValue = valueTemp;
          }

          loadData.push(valueTemp);
          // allValues.push(valueTemp);
        });
        const loadSeries: Series = new Series(this.labelLoad, loadData);
        loadSeries.tooltip = Config.getChartTooltip("%");
        loadSeries.color = "#85D9FF";
        series.push(loadSeries);

        // console.log(JSON.stringify(series));

        xAxisCategories.forEach((key: string) => {
          (this.nodeLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
        });
        if(this.forecastLaDataMap.length > 0){
          (this.nodeLoadingOptions.xAxis  as Highcharts.XAxisOptions).plotBands = [{
            color:"#dddddd",
            from: (this.nodeLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastLaDataMap[0]) - 0.5,
            to: (this.nodeLoadingOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastLaDataMap[this.forecastLaDataMap.length - 1]) + 0.5,
          }]
        }
        // allValues.sort();
        // console.log(allValues);
         this.nodeLoadingOptions.yAxis[0].max = maximumValue * 1.1;
         this.nodeLoadingOptions.yAxis[0].min = 0;
       //his.nodeLoadingOptions.yAxis[0].max = allValues[allValues.length - 1] + ((allValues[allValues.length - 1] * 10) / 100);

        this.nodeLoadingOptions.yAxis[0].plotLines[0].value =
          laNodeData.nodeViolationLimitPercent;
        this.nodeLoadingOptions.series = JSON.parse(JSON.stringify(series));
        // console.log(JSON.stringify(this.gmonTimeViewOptions));
        if (this.nodeLoadingChart) {
          this.nodeLoadingChart.options = this.nodeLoadingOptions;
        }

      },
      (error) => {
        console.error(error);

      }
    );

    clearInterval(this.intervalVariable);


    this.updateNodeLoadingChartFalse = true;
  }

  loadReactivePowerAnalysis(): void {
    setTimeout(() => {

    });

    this.applicationService.getReactivePowerAnalysisData([this.gridElementId]).subscribe(
      (rpaResultsStr: string) => {

        // console.log("rpaResults = " + JSON.stringify(rpaResultsStr));
        let rpaResults: ReactivePowerAnalysis; // = new ReactivePowerAnalysis();
        rpaResults = JSON.parse(rpaResultsStr);
        if (rpaResults == null) {
          this.areRPADataNull = true;

          return;
        }
        this.areRPADataNull = false;
        const xAxisCategories: Map<string, string> = new Map<string, string>();
        const reactivePowerAnalysisSeries: Array<Series> = new Array<Series>();
        let activePowerData: Array<number> = new Array<number>();
        let reactivePowerData: Array<number> = new Array<number>();
        const rpaIntervalResultsDtoLists: Array<IntervalResults> =
          rpaResults.rpaIntervalResultsDtoList;
        rpaIntervalResultsDtoLists.forEach((value, index) => {
          /*
                    const timestamp = value.timestamp;
                    xAxisCategories.set(timestamp, timestamp);

                    activePowerData.push(value.activePower_kW);
                    reactivePowerData.push(value.reactivePower_kVar);
          */
          const timestamp = value.timestamp;
          xAxisCategories.set(timestamp, timestamp);
          // console.log("X-Axis: " + xAxisCategories.get(timestamp) + " -- " + timestamp);
          // Array.from(xAxisCategories.keys()).forEach((key: string) => {
          //   console.log("X-Axis: " + key + " -- " + xAxisCategories.get(key));
          // });

          let valueTempActive = null;
          let valueTempReactive = null;
          //console.log(value.timestamp + " -- " + value.activePower_kW + " -- " + value.reactivePower_kVar)
          if (value.activePower_kW != null) {
            valueTempActive = parseFloat(NumberUtils.format1(value.activePower_kW, 2));
          }

          if (value.reactivePower_kVar != null) {
            valueTempReactive = parseFloat(NumberUtils.format1(value.reactivePower_kVar, 2));
          }
          //console.log(valueTempActive + " -- " + valueTempReactive)
          activePowerData.push(valueTempActive);
          reactivePowerData.push(valueTempReactive);

          if(value.source == "forecast"){
            this.forecastDataMap.push(value.timestamp);
          }
        });


        let tooltipKW: any;
        let tooltipKVAR: any;

        if ((reactivePowerData.some(a => Math.abs(a) > 1200)) || (activePowerData.some(a => Math.abs(a) > 1200))) {
          tooltipKW = Config.getChartTooltip("MW");
          tooltipKVAR = Config.getChartTooltip("MVAR");

          activePowerData = activePowerData.map(val => {
            if (val != null) return parseFloat((val / 1000).toFixed(3)); else return val;
          });
          reactivePowerData = reactivePowerData.map(val => {
            if (val != null) return parseFloat((val / 1000).toFixed(3)); else return val;
          });

          this.reactivePowerAnalysisOptions.yAxis[0].title.text = this.translations["code-string"]["Active-Power"] + " [MW]";
          this.reactivePowerAnalysisOptions.yAxis[1].title.text = this.translations["code-string"]["Reactive-Power"] + " [MVAR]";
        } else {
          tooltipKW = Config.getChartTooltip("kW");
          tooltipKVAR = Config.getChartTooltip("kVAR");
          this.reactivePowerAnalysisOptions.yAxis[0].title.text = this.translations["code-string"]["Active-Power"] + " [kW]";
          this.reactivePowerAnalysisOptions.yAxis[1].title.text = this.translations["code-string"]["Reactive-Power"] + " [kVAR]";
        }

        let activePowerSeriesObj;
        let reactivePowerSeriesObj;
        activePowerSeriesObj = new Series(
          this.labelActivePower,
          activePowerData
        );
        activePowerSeriesObj.tooltip = tooltipKW;
        reactivePowerAnalysisSeries.push(activePowerSeriesObj);
        reactivePowerSeriesObj = new Series(
          this.labelReactivePower,
          reactivePowerData
        );
        activePowerSeriesObj.color = "#85D9FF";
        reactivePowerSeriesObj.color = "#C0FE76";

        // reactivePowerAtRootSeriesObj.yAxis = 1;
        reactivePowerSeriesObj.tooltip = tooltipKVAR;
        reactivePowerAnalysisSeries.push(reactivePowerSeriesObj);

        // Render X axis
        xAxisCategories.forEach((key: string) => {
          (this.reactivePowerAnalysisOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
        });

        if(this.forecastDataMap.length > 0){
          (this.reactivePowerAnalysisOptions.xAxis as Highcharts.XAxisOptions).plotBands = [{
            color:"#dddddd",
            from: (this.reactivePowerAnalysisOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastDataMap[0]) - 0.5,
            to: (this.reactivePowerAnalysisOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastDataMap[this.forecastDataMap.length - 1]) + 0.5,
          }]
        }

        this.reactivePowerAnalysisOptions.series = JSON.parse(
          JSON.stringify(reactivePowerAnalysisSeries)
        );
        //console.log(JSON.stringify(this.reactivePowerAnalysisOptions));
        if (this.reactivePowerAnalysisChart) {
          this.reactivePowerAnalysisChart.options = this.reactivePowerAnalysisOptions;
        }

        this.updateReadtivePowerAnalysisChartFlag = true;
      },
      (err) => {
        this.areRPADataNull = true;
        console.log(err);

      }

    );

    clearInterval(this.intervalVariable);

  }

  loadReactivePowerViolations(): void {

    setTimeout(() => {

    });


    this.applicationService.getReactivePowerAnalysisData([this.gridElementId]).subscribe(
      (rpvResultsStr: string) => {
        console.log("rpvResults = " + JSON.stringify(rpvResultsStr));
        let rpvResults: ReactivePowerAnalysis; // = new ReactivePowerAnalysis();
        rpvResults = JSON.parse(rpvResultsStr);
        ///   rpvResults = rpvResultsStr; ///
        if (rpvResults == null) {
          this.areRPVDataNull = true;

          return;
        }
        this.areRPVDataNull = false;
        const rpaViolationResultDtoLists: Map<string, ViolationResults> =
          rpvResults.rpaViolationResultDtoList;

        try {
          const violationsValue = new Map(
            Object.entries(rpaViolationResultDtoLists)
          ).get("1.0");

          if (
            violationsValue.inductiveViolations_number <= 0 ||
            !violationsValue.inductiveViolations_number
          ) {
            this.rpvTextUp = "";
            console.log("inductive violations :" + this.rpvTextUp);
          } else {
            this.rpvTextUp =
              this.labelInductiveViolations + ": " + violationsValue.inductiveViolations_number + "\n(" +
              violationsValue.inductiveViolationsDay_number +
              " " + this.labelDays + ", " +
              violationsValue.inductiveViolationsNight_number +
              " " + this.labelNights + ").";
          }

          if (
            violationsValue.capacitiveViolations_number <= 0 ||
            !violationsValue.capacitiveViolations_number
          ) {
            this.rpvTextDown = "";
          } else {
            this.rpvTextDown =
              this.labelCapacitiveViolations + ": " + violationsValue.capacitiveViolations_number + "\n(" +
              violationsValue.capacitiveViolationsDay_number +
              " " + this.labelDays + ", " +
              violationsValue.capacitiveViolationsNight_number +
              " " + this.labelNights + ").";
          }
        } catch (e) {
          console.log(e instanceof TypeError); // true
          console.log(e.message); // "null has no properties"
          console.log(e.name); // "TypeError"
          console.log(e.fileName);
          console.log(e.lineNumber);
          console.log(e.columnNumber);
          console.log(e.stack);
        }

        const reactivePowerViolationsSeries: Array<Series> = new Array<Series>();
        let xyDayData = new Array<any>();
        let xyNightData = new Array<any>();
        let activePowerAtRootData: Array<number> = new Array<number>();
        let reactivePowerAtRootData: Array<number> = new Array<number>();
        let activePowerTemp: Array<number> = new Array<number>();
        let reactivePowerTemp: Array<number> = new Array<number>();

        let activePower: number;
        let reactivePower: number;

        let smallest_xvalue_in_caseofnodata = 50;  // use 10kW for plotting range in case there are no positive active power values

        let scaleChartToMega: boolean = false;
        rpvResults.rpaIntervalResultsDtoList.forEach((value) => {
          activePowerTemp.push(value.activePower_kW);
          reactivePowerTemp.push(value.reactivePower_kVar);
        });

        if ((activePowerTemp.some(a => Math.abs(a) > 1200)) || (reactivePowerTemp.some(a => Math.abs(a) > 1200))) {
          scaleChartToMega = true
        }

        if (scaleChartToMega) {
          (this.reactivePowerViolationsOptions.xAxis as Highcharts.XAxisOptions).title.text = this.translations["code-string"]["Active-Power"] + " [MW]";
          (this.reactivePowerViolationsOptions.yAxis as Highcharts.YAxisOptions).title.text = this.translations["code-string"]["Reactive-Power"] + " [MVAR]";

          smallest_xvalue_in_caseofnodata = parseFloat((smallest_xvalue_in_caseofnodata / 1000).toFixed(3));

          rpvResults.rpaIntervalResultsDtoList.forEach((value) => {

            if (value.activePower_kW != null && value.reactivePower_kVar != null) {
              activePower = parseFloat((value.activePower_kW / 1000).toFixed(3));
              reactivePower = parseFloat((value.reactivePower_kVar / 1000).toFixed(3));
              const arr = [activePower, reactivePower];
              activePowerAtRootData.push(activePower);
              reactivePowerAtRootData.push(reactivePower);

              if (value.day === true) {
                xyDayData.push(arr);
              } else {
                xyNightData.push(arr);
              }
            }
          });

        } else {
          (this.reactivePowerViolationsOptions.xAxis as Highcharts.XAxisOptions).title.text = this.translations["code-string"]["Active-Power"] + " [kW]";
          (this.reactivePowerViolationsOptions.yAxis as Highcharts.YAxisOptions).title.text = this.translations["code-string"]["Reactive-Power"] + " [kVAR]";

          rpvResults.rpaIntervalResultsDtoList.forEach((value) => {

            if (value.activePower_kW != null && value.reactivePower_kVar != null) {
              activePower = parseFloat(value.activePower_kW.toFixed(3));
              reactivePower = parseFloat(value.reactivePower_kVar.toFixed(3));
              const arr = [activePower, reactivePower];
              activePowerAtRootData.push(activePower);
              reactivePowerAtRootData.push(reactivePower);

              if (value.day === true) {
                xyDayData.push(arr);
              } else {
                xyNightData.push(arr);
              }
            }
          });
        }

        const daySeriesObj = new Series(this.labelDay, xyDayData);
        const nightSeriesObj = new Series(this.labelNight, xyNightData);

        daySeriesObj.type = "scatter";
        nightSeriesObj.type = "scatter";

        daySeriesObj.color = "#C0FE76";
        nightSeriesObj.color = "#85D9FF";

        // polygones
        // Y = x*q2Slope + q2Intercept
        const polygone1: number[][] = [];
        const polygone2: number[][] = [];
        const polygone3: number[][] = [];
        const polygone4: number[][] = [];
        // let polygone:number[][] = [];

        //rpvResults.q1Intercept = 10;
        // rpvResults.q1Slope = 0.5;
        //rpvResults.q2Intercept = 15;
        // rpvResults.q2Slope = -0.1;
        // rpvResults.q3Intercept = -20;
        // rpvResults.q3Slope = 1;
        // rpvResults.q4Intercept = -10;
        // rpvResults.q4Slope = -0.2;

        let q1I = rpvResults.q1Intercept;
        const q1S = rpvResults.q1Slope;
        let q2I = rpvResults.q2Intercept;
        const q2S = rpvResults.q2Slope;
        let q3I = rpvResults.q3Intercept;
        const q3S = rpvResults.q3Slope;
        let q4I = rpvResults.q4Intercept;
        const q4S = rpvResults.q4Slope;

        if (scaleChartToMega) {

          q1I = q1I / 1000;
          q2I = q2I / 1000;
          q3I = q3I / 1000;
          q4I = q4I / 1000;
        }

        const xminActive = Math.min(...activePowerAtRootData);
        const xmaxActive = Math.max(...activePowerAtRootData);
        const yminReactive = Math.min(...reactivePowerAtRootData);
        const ymaxReactive = Math.max(...reactivePowerAtRootData);
        //       const eps = Config.getEpsilonRPV(ymaxReactive);
        // let eps =  1000 - ymaxReactive % 1000;
        // console.log('eps : '+ eps);
        // let eps = 0;

        //const p0 = [0, 0];
//        const p0Up = [0, ymaxReactive + eps];
        let p0Down;

        let offset = 1;

        let intercept_factor = 1.1; // multiplied by 1.1 to go 10% higher in case of the intercepts, i.e. to make sure the violation region is shown

        let ymax = Math.max(ymaxReactive, intercept_factor * Math.max(q1I, q2I) + offset);  // maximum over data and two scaled relevant intercepts for upper part of graph;
        let ymin = Math.min(yminReactive, intercept_factor * Math.min(q3I, q4I) - offset);  //% analog, using minimum, for Q3 and Q4, lower part of graph

        let xmax = Math.max(xmaxActive, smallest_xvalue_in_caseofnodata);
        let xmin = Math.min(xminActive, -1 * smallest_xvalue_in_caseofnodata); // note the negation of the smallest value


        console.log("X min active: " + xmin);
        console.log("X max active: " + xmax);
        console.log("Y min reactive: " + ymin);
        console.log("Y max reactive: " + ymax);
//        console.log("Epsilon: " + eps);
        console.log(q1I);
        console.log(q2I);
        console.log(q3I);
        console.log(q4I);

//        if (xminActive < 0 && ymaxReactive > 0 && ymaxReactive+eps > q2I) {
        let p02 = [0, q2I];
        let p02up = [0, ymax];
//          let p2 = [0, 0];
        if (q2S !== 0) {
          polygone2.push(p02);
          //if (q2I !== 0) {
          //  const p22 = [q2I / q2S, q2I];
          //  polygone2.push(p22);
          //}
//            p2 = [(ymaxReactive + eps - q2I) / q2S, ymaxReactive + eps];
          let p22 = [(ymax - q2I) / q2S, ymax];
          polygone2.push(p22);
          polygone2.push(p02up);
        } else {
          polygone2.push(p02);
          const p22 = [xmin, q2I];
//            const p22 = [xminActive, q2I];
          polygone2.push(p22);
//            p2 = [xminActive, ymaxReactive + eps];
          let p2 = [xminActive, ymax];
          polygone2.push(p2);
          polygone2.push(p02up);
        }
//        }

//        if (xmaxActive > 0 && ymaxReactive > 0 && ymaxReactive+eps > q1I) {
        let p01 = [0, q1I];
        let p01up = [0, ymax];
//          let p1 = [0, 0];
        if (q1S !== 0) {
          polygone1.push(p01);
          polygone1.push(p01up);
          let p11 = [(ymax - q1I) / q1S, ymax];
          polygone1.push(p11);
          //if (q1I !== 0) {
          //  const p11 = [q1I / q1S, q1I];
          //  polygone1.push(p11);
          //}
        } else {
          polygone1.push(p01);
          polygone1.push(p01up);
          let p11 = [xmax, ymax];
          polygone1.push(p11);
          const p111 = [xmax, q1I];
          polygone1.push(p111);
        }
//        }

//        if (xmaxActive > 0 && yminReactive < 0 && yminReactive-eps < q4I) {
        let p04 = [0, q4I];
        let p4 = [(ymin - q4I) / q4S, ymin];
        p0Down = [0, ymin];
        /*          let p4 = [0, 0];

                  if (yminReactive > q4I)
                    p0Down = [0, 1.1 * Math.min(yminReactive, q4I)];
                  else
                    p0Down = [0, yminReactive - eps];
        */
        if (q4S !== 0) {
          polygone4.push(p04);
          //if (q4I !== 0) {
          //  const p44 = [q4I / q4S, q4I];
          //  polygone4.push(p44);
          //}
//            p4 = [(yminReactive - eps - q4I) / q4S, yminReactive - eps];

          polygone4.push(p4);
          polygone4.push(p0Down);

        } else {

          polygone4.push(p04);
          const p44 = [xmax, q4I];
          polygone4.push(p44);
          /*
                      if (yminReactive > q4I)
                        p4 = [xmaxActive, 1.1 * Math.min(yminReactive, q4I)];
                      else
                        p4 = [xmaxActive, yminReactive - eps];
          */
          p4 = [xmax, ymin];
          polygone4.push(p4);

          polygone4.push(p0Down);
        }
//        }

//        if (xminActive < 0 && yminReactive < 0 && yminReactive-eps < q3I) {
        let p03 = [0, q3I];
        let p3 = [(ymin - q3I) / q3S, ymin];
        p0Down = [0, ymin];
        /*
                  if (yminReactive > q3I)
                    p0Down = [0, 1.1 * Math.min(yminReactive, q3I)];
                  else
                    p0Down = [0, yminReactive - eps];
        */
        if (q3S !== 0) {
          polygone3.push(p03);
          polygone3.push(p0Down);
//            p3 = [(yminReactive - eps - q3I) / q3S, yminReactive - eps];
          polygone3.push(p3);
          //if (q3I !== 0) {
          //  const p33 = [-q3I / q3S, q3I];
          //  polygone2.push(p33);
          //}
        } else {
          polygone3.push(p03);
          polygone3.push(p0Down);
          /*
                      if (yminReactive > q3I)
                        p3 = [xminActive, 1.1 * Math.min(yminReactive, q3I)];
                      else
                      */
          p3 = [xmin, ymin];

          polygone3.push(p3);
          const p33 = [xmin, q3I];
          polygone3.push(p33);
        }
//        }

        console.log("polygone1: ")
        console.log(polygone1)

        console.log("polygone2: ")
        console.log(polygone2)


        console.log("polygone3: ")
        console.log(polygone3)

        console.log("polygone4: ")
        console.log(polygone4)


        // let islegendNameShow = false;
        if (polygone2.length !== 0) {
          const polygone2Obj = new Series(
            this.labelInductiveViolationArea + "(Q2)",
            polygone2
          );
          polygone2Obj.type = "polygon";
          polygone2Obj.color = "#F54D65";
          //  islegendNameShow = true;
          polygone2Obj.enableMouseTracking = false;
          reactivePowerViolationsSeries.push(polygone2Obj);
        }
        if (polygone1.length !== 0) {
          const polygone1Obj = new Series(
            this.labelInductiveViolationArea + "(Q1)",
            polygone1
          );
          polygone1Obj.type = "polygon";
          polygone1Obj.color = "#F54D65";
          polygone1Obj.enableMouseTracking = false;
          reactivePowerViolationsSeries.push(polygone1Obj);
          /*  if (islegendNameShow) {
          polygone1Obj.showInLegend = false;
        }*/
        }
        // islegendNameShow = false;
        console.log("polygone4length " + polygone4.length);
        if (polygone4.length !== 0) {
          const polygone4Obj = new Series(
            this.labelCapacitiveViolationArea + "(Q4)",
            polygone4
          );
          polygone4Obj.type = "polygon";
          polygone4Obj.color = "#F54D65";
          polygone4Obj.enableMouseTracking = false;
          reactivePowerViolationsSeries.push(polygone4Obj);
          // islegendNameShow = true;
        }
        console.log("polygone3length " + polygone3.length);
        if (polygone3.length !== 0) {
          const polygone3Obj = new Series(
            this.labelCapacitiveViolationArea + "(Q3)",
            polygone3
          );
          polygone3Obj.type = "polygon";
          polygone3Obj.color = "#F54D65";
          polygone3Obj.enableMouseTracking = false;
          reactivePowerViolationsSeries.push(polygone3Obj);
          /*if (islegendNameShow) {
          polygone3Obj.showInLegend = false;
        }*/
        }

        // add the series
        reactivePowerViolationsSeries.push(daySeriesObj);
        reactivePowerViolationsSeries.push(nightSeriesObj);

        this.reactivePowerViolationsOptions.series = JSON.parse(
          JSON.stringify(reactivePowerViolationsSeries)
        );

        if (this.reactivePowerViolationsChart) {
          this.reactivePowerViolationsChart.options =
            this.reactivePowerViolationsOptions;
        }

        this.updateReactivePowerViolationsChartFlag = true;
      },
      (err) => {
        console.log(err);
        this.areRPVDataNull = true;

      }
    );


    clearInterval(this.intervalVariable);


  }

  loadGPlanLATimeView() {
    setTimeout(() => {

    });

    this.applicationService.getGplanLANodeData(this.selectedScenario.id, this.gridElementId).subscribe(
      (gplanLAResults: string) => {
        console.log("gplanLAResults: " + gplanLAResults);
        if (!gplanLAResults) {

          return;
        }
        const gplanLAData: LoadingAnalysisData = JSON.parse(gplanLAResults);
        console.log("gplanLANodeData: " + gplanLAData);

        const xAxisCategories: Map<string, string> = new Map<string, string>();
        const series: Array<Series> = new Array<Series>();

        // let allValues: Array<number> = new Array<number>();

        const gplanLoadData: Array<number> = new Array<number>();
        gplanLAData.intervals.forEach((value) => {
          const timestamp = value.timestamp;
          xAxisCategories.set(timestamp, timestamp);

          let valueFloat = null;
          if (value != null && value.loadPercent != null && value.loadPercent != 0.0) {
            valueFloat = parseFloat(NumberUtils.format1(value.loadPercent, 2));
          }
          gplanLoadData.push(valueFloat);
            // gplanLoadData.push(value.loadPercent);
            // console.log("laNodeValue: " + valueFloat);
            // allValues.push(valueFloat);
        });
        const gplanLoadSeries: Series = new Series(
          this.labelPlanningLoad,
          gplanLoadData
        );
        gplanLoadSeries.tooltip = Config.getChartTooltip("%");
        gplanLoadSeries.color = "#0569C3";   //dark blue
        series.push(gplanLoadSeries);

        // console.log(JSON.stringify(series));
        this.applicationService
          .getLANodeDataInPlanning(this.selectedScenario.id, this.gridElementId)
          .subscribe((laResults: string) => {
            // console.log("laNodeLoadingResults: " + laNodeLoadingResults);
            if (!laResults || laResults.length == 0) {

              xAxisCategories.forEach((key: string) => {
                (this.gplanLATimeViewOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
              });

              this.gplanLATimeViewOptions.yAxis[0].plotLines[0].value =
                gplanLAData.nodeViolationLimitPercent;
              this.gplanLATimeViewOptions.series = JSON.parse(
                JSON.stringify(series)
              );

              console.log(JSON.stringify(this.gplanLATimeViewOptions));
              console.log("LA chart: " + this.gplanLATimeViewChart);
              if (this.gplanLATimeViewChart) {
                this.gplanLATimeViewChart.options = this.gplanLATimeViewOptions;
              }

            } else {
              const laNodeData: LoadingAnalysisData = JSON.parse(laResults);
              // console.log("laNodeData: " + laNodeData);

              // let allValues: Array<number> = new Array<number>();

              const loadData: Array<number> = new Array<number>();
              laNodeData.intervals.forEach((value) => {
              if(value.source == "forecast"){
                this.forecastLaPlanningDataMap.push(value.timestamp);
               }
                const timestamp = value.timestamp;
                xAxisCategories.set(timestamp, timestamp);
                let valueFloat = null;
                if (value != null && value.loadPercent != null) {
                  valueFloat = parseFloat(NumberUtils.format1(value.loadPercent, 2));
                }
                loadData.push(valueFloat);
                  // console.log("laNodeValue: " + valueFloat);
                  // allValues.push(valueFloat);
              });
              const loadSeries: Series = new Series(this.labelLoad, loadData);
              loadSeries.tooltip = Config.getChartTooltip("%");
              loadSeries.color = "#85D9FF";    //light blue
              series.push(loadSeries);
            }

            xAxisCategories.forEach((key: string) => {
              (this.gplanLATimeViewOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
            });


            this.gplanLATimeViewOptions.yAxis[0].plotLines[0].value =
              gplanLAData.nodeViolationLimitPercent;
            this.gplanLATimeViewOptions.series = JSON.parse(
              JSON.stringify(series)
            );
            if(this.forecastLaPlanningDataMap.length > 0){
              (this.gplanLATimeViewOptions.xAxis as Highcharts.XAxisOptions).plotBands = [{
                color:"#dddddd",
                from: (this.gplanLATimeViewOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastLaPlanningDataMap[0]) - 0.5,
                to: (this.gplanLATimeViewOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastLaPlanningDataMap[this.forecastLaPlanningDataMap.length - 1]) + 0.5,
              }]
            }
            if (this.gplanLATimeViewChart) {
              this.gplanLATimeViewChart.options = this.gplanLATimeViewOptions;
              console.log(
                "LA chart options: " + this.gplanLATimeViewChart.options
              );
              console.log(
                "gplanLATimeViewChart has type :" +
                typeof this.gplanLATimeViewChart
              );
            }
            this.updateGplanLATimeViewChartFlag = true;
          });
      },
      (error) => {
        console.error(error);

      }
    );

    clearInterval(this.intervalVariable);
  }


  loadGPlanLATimeViewWorstCase() {
    setTimeout(() => {

    });

    this.gplanLATimeViewOptions.chart.type = "column"
    this.applicationService.getGplanLANodeData(this.selectedScenario.id, this.gridElementId).subscribe(
      (gplanLAResults: string) => {
        console.log("gplanLAResults: " + gplanLAResults);
        if (!gplanLAResults) {

          return;
        }
        const gplanLAData: LoadingAnalysisData = JSON.parse(gplanLAResults);
        console.log("gplanLANodeData: " + gplanLAData);

        const xAxisCategories: Map<string, string> = new Map<string, string>();
        const series: Array<Series> = new Array<Series>();

        // let allValues: Array<number> = new Array<number>();

        const gplanLoadData: Array<number> = new Array<number>();
        gplanLAData.intervals.forEach((value) => {
          const timestamp = value.timestamp;
          xAxisCategories.set(timestamp, timestamp);
          let valueFloat = null;
          if (value != null && value.loadPercent != null)
            valueFloat = parseFloat(NumberUtils.format1(value.loadPercent, 2))
          gplanLoadData.push(valueFloat);
          // gplanLoadData.push(value.loadPercent);
          // console.log("laNodeValue: " + valueFloat);
          // allValues.push(valueFloat);
        });
        const gplanLoadSeries: Series = new Series(
          this.labelWorstCaseLoad,
          gplanLoadData
        );
        gplanLoadSeries.tooltip = Config.getChartTooltip("%");

        series.push(gplanLoadSeries);

        // console.log(JSON.stringify(series));
        this.applicationService
          .getLANodeDataInPlanning(this.selectedScenario.id, this.gridElementId)
          .subscribe((laResults: string) => {
            // console.log("laNodeLoadingResults: " + laNodeLoadingResults);
            if (!laResults || laResults.length == 0) {

              xAxisCategories.forEach((key: string) => {
                (this.gplanLATimeViewOptions.xAxis as Highcharts.XAxisOptions).categories!.push(key);
              });

              this.gplanLATimeViewOptions.yAxis[0].plotLines[0].value =
                gplanLAData.nodeViolationLimitPercent;
              this.gplanLATimeViewOptions.series = JSON.parse(
                JSON.stringify(series)
              );

              console.log(JSON.stringify(this.gplanLATimeViewOptions));
              console.log("LA chart: " + this.gplanLATimeViewChart);
              if (this.gplanLATimeViewChart) {
                this.gplanLATimeViewChart.options = this.gplanLATimeViewOptions;
              }
            } else {

              const laNodeData: LoadingAnalysisData = JSON.parse(laResults);
              // console.log("laNodeData: " + laNodeData);

              // let allValues: Array<number> = new Array<number>();

              const loadData: Array<number> = new Array<number>();
              laNodeData.intervals.forEach((value) => {
                const timestamp = value.timestamp;
                xAxisCategories.set(timestamp, timestamp);
                let valueFloat = null;
                if (value != null && value.loadPercent != null)
                  valueFloat = parseFloat(NumberUtils.format1(value.loadPercent, 2))
                loadData.push(valueFloat);
                // console.log("laNodeValue: " + valueFloat);
                // allValues.push(valueFloat);
              });
              const loadSeries: Series = new Series(this.labelWorstCaseLoading, loadData);
              loadSeries.tooltip = Config.getChartTooltip("%");

              series.push(loadSeries);
              console.log("series:");

              console.log(JSON.stringify(series));

            }

            xAxisCategories.forEach((key: string) => {
              (this.gplanLATimeViewOptions.xAxis as Highcharts.XAxisOptions).categories!.push(key);
            });

            this.gplanLATimeViewOptions.yAxis[0].plotLines[0].value =
              gplanLAData.nodeViolationLimitPercent;
            this.gplanLATimeViewOptions.series = JSON.parse(
              JSON.stringify(series)
            );

            if (this.gplanLATimeViewChart) {
              this.gplanLATimeViewChart.options = this.gplanLATimeViewOptions;
              console.log(
                "LA chart options: " + this.gplanLATimeViewChart.options
              );
              console.log(
                "gplanLATimeViewChart has type :" +
                typeof this.gplanLATimeViewChart
              );
            }

            this.updateGplanLATimeViewChartFlag = true;

          });
      },
      (error) => {
        console.error(error);

      }
    );


    clearInterval(this.intervalVariable);
  }

  loadGPlanGmonTimeView(): void {
    setTimeout(() => {

    });

    this.isGPlanGmonChartEmpty = false;

    this.applicationService.getGplanGmonData(this.selectedScenario.id, this.gridElementId).subscribe(
      (gplanResults: string) => {
        console.log("gplan_gmon_results: " + gplanResults);
        if (!gplanResults || gplanResults.length === 0) {
          this.isGPlanGmonChartEmpty = true;

          return;
        }
        const gPlanOutputData = JSON.parse(gplanResults);

        const xAxisCategories: Map<string, string> = new Map<string, string>();
        const tooltipV = Config.getChartTooltip("V");
        const series: Array<Series> = new Array<Series>();

        const lvDataPlan: Array<number> = new Array<number>();
        // planning
        gPlanOutputData.voltageResult.average.forEach((value) => {
          const timestamp = value.timestamp;
          xAxisCategories.set(timestamp, timestamp);
          let valueFloat = null;
          if (value != null && value.value != null)
            valueFloat = parseFloat(NumberUtils.format1(value.value, 2));
          lvDataPlan.push(valueFloat);
        });

        const lvSeriesPlan: Series = new Series(
          this.labelPlanningLowerTenPercentQuantiles,
          lvDataPlan
        );
        lvSeriesPlan.visible = false;
        lvSeriesPlan.tooltip = tooltipV;
        lvSeriesPlan.color = "#26C02D";      //dark green
        series.push(lvSeriesPlan);

        const uvDataPlan: Array<number> = new Array<number>();
        gPlanOutputData.voltageResult.average.forEach((value) => {
          const timestamp = value.timestamp;
          // console.log("timestamp1: " + timestamp)
          xAxisCategories.set(timestamp, timestamp);
          let valueFloat = null;
          if (value != null && value.value != null)
            valueFloat = parseFloat(NumberUtils.format1(value.value, 2));
          uvDataPlan.push(valueFloat);
        });
        const uvSeriesPlan: Series = new Series(
          this.labelPlanningUpperTenPercentQuantiles,
          uvDataPlan
        );
        uvSeriesPlan.visible = false;
        uvSeriesPlan.tooltip = tooltipV;
        uvSeriesPlan.color = "#26C02D";     //planning upper 10% quantile
        series.push(uvSeriesPlan);

        const mvDataPlan: Array<number> = new Array<number>();
        gPlanOutputData.voltageResult.average.forEach((value, index) => {
          const timestamp = value.timestamp;
          // console.log("timestamp2: " + timestamp)
          xAxisCategories.set(timestamp, timestamp);
          let valueFloat = null;
          if (value != null && value.value != null)
            valueFloat = parseFloat(NumberUtils.format1(value.value, 2));
          mvDataPlan.push(valueFloat);
        });
        const mediumSeriesPlan: Series = new Series(
          this.labelPlanningVoltage,
          mvDataPlan
        );
        mediumSeriesPlan.color = "#0569C3";             //dark blue
        mediumSeriesPlan.tooltip = tooltipV;
        series.push(mediumSeriesPlan);

        this.applicationService
          .getGmonDataPlanning(this.selectedScenario.id, this.gridElementId)
          .subscribe((gmonResults: string) => {
            console.log("gmon_results: " + gmonResults)
            if (!gmonResults || gmonResults.length == 0) {
              // this.isGPlanGmonChartEmpty = true;
              // return;
              xAxisCategories.forEach((key: string) => {
                (this.gplanGmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
              });
              this.gplanGmonTimeViewOptions.series = JSON.parse(
                JSON.stringify(series)
              );
              // console.log(JSON.stringify(this.gmonTimeViewOptions));
              this.gplanGmonTimeViewOptions.yAxis[0].plotLines[0].value =
                gPlanOutputData.voltageResult.upperViolationLimit;
              this.gplanGmonTimeViewOptions.yAxis[0].plotLines[1].value =
                gPlanOutputData.voltageResult.lowerViolationLimit;

              if (this.gplanGmonTimeViewChart) {
                this.gplanGmonTimeViewChart.options =
                  this.gplanGmonTimeViewOptions;
              }


            } else {

              const gMonOutputData = JSON.parse(gmonResults);

              const lvData: Array<number> = new Array<number>();
              gMonOutputData.voltageResult.average.forEach((value) => {
                const timestamp = value.timestamp;
                xAxisCategories.set(timestamp, timestamp);
               if(value.source == "forecast"){
                  this.forecastGmonPlanningDataMap.push(value.timestamp);
               }
                let valueFloat = null;
                if (value != null && value.value != null) {
                  valueFloat = parseFloat(
                    NumberUtils.format1(value.value, 2)
                  );
                }
                lvData.push(valueFloat);
                // allValues.push(valueFloat);
              });
              const lvSeries: Series = new Series(this.labelLowerTenPercentQuantiles, lvData);
              lvSeries.visible = false;
              lvSeries.tooltip = tooltipV;
              lvSeries.color = "#C0FE76";       //bright green
              series.push(lvSeries);

              const uvData: Array<number> = new Array<number>();

              gMonOutputData.voltageResult.average.forEach((value) => {
                const timestamp = value.timestamp;
                xAxisCategories.set(timestamp, timestamp);
                let valueFloat1 = null;
                if (value != null && value.value != null) {
                  valueFloat1 = parseFloat(
                    NumberUtils.format1(value.value, 2)
                  );
                }
                uvData.push(valueFloat1);
                  // allValues.push(valueFloat);
              });
              const uvSeries: Series = new Series(this.labelUpperTenPercentQuantiles, uvData);
              uvSeries.visible = false;
              uvSeries.tooltip = tooltipV;
              uvSeries.color = "#C0FE76";       //bright green
              series.push(uvSeries);

              const mvData: Array<number> = new Array<number>();
              gMonOutputData.voltageResult.average.forEach((value) => {
                const timestamp = value.timestamp;
                xAxisCategories.set(timestamp, timestamp);
                let valueFloat2 = null;
                if (value != null && value.value != null) {
                  valueFloat2 = parseFloat(
                    NumberUtils.format1(value.value, 2)
                  );
                }
                mvData.push(valueFloat2);
                  // allValues.push(valueFloat);
              });
              const mediumSeries: Series = new Series(this.labelVoltage, mvData);
              mediumSeries.color = "#85D9FF";     //bright blue
              mediumSeries.tooltip = tooltipV;
              series.push(mediumSeries);

              // console.log(JSON.stringify(series));

              xAxisCategories.forEach((key: string) => {
                (this.gplanGmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories.push(key);
              });
              if(this.forecastGmonPlanningDataMap.length > 0){
                  (this.gplanGmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).plotBands = [{
                  color:"#dddddd",
                  from: (this.gplanGmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastGmonPlanningDataMap[0]) - 0.5,
                  to: (this.gplanGmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories.indexOf(this.forecastGmonPlanningDataMap[this.forecastGmonPlanningDataMap.length - 1]) + 0.5,
                }]
              }
              // allValues.sort();
              // console.log(allValues);
              // this.gmonTimeViewOptions.yAxis[0].min = allValues[0] * 0.9;
              // this.gmonTimeViewOptions.yAxis[0].max = allValues[allValues.length - 1] * 1.1;
              this.gplanGmonTimeViewOptions.yAxis[0].plotLines[0].value =
                gPlanOutputData.voltageResult.upperViolationLimit;
              this.gplanGmonTimeViewOptions.yAxis[0].plotLines[1].value =
                gPlanOutputData.voltageResult.lowerViolationLimit;

              this.gplanGmonTimeViewOptions.series = JSON.parse(
                JSON.stringify(series)
              );
              // console.log(JSON.stringify(this.gmonTimeViewOptions));
              console.log("Gplan chart: " + this.gplanGmonTimeViewChart);
              if (this.gplanGmonTimeViewChart) {
                this.gplanGmonTimeViewChart.options =
                  this.gplanGmonTimeViewOptions;
                console.log(
                  "gplanGmonTimeViewChart has type :" +
                  typeof this.gplanGmonTimeViewChart
                );
              }
            }
            this.updateGplanGmonTimeViewChartFlag = true;
          });
      },
      (error) => {
        console.error(error);
      }
    );

    clearInterval(this.intervalVariable);
  }


  checkWorstCase() {
    if (this.selectedScenario && this.selectedScenario.type == "WC") {
      this.worstCase = true
    } else {
      this.worstCase = false
    }

    return this.worstCase
  }

  loadGPlanGmonTimeViewWorstCase(): void {
    setTimeout(() => {

    });

    this.isGPlanGmonChartEmpty = false;
    this.gplanGmonTimeViewOptions.chart.type = "column"
    this.applicationService.getGplanGmonData(this.selectedScenario.id, this.gridElementId).subscribe(
      (gplanResults: string) => {
        console.log("gplan_gmon_results: " + gplanResults);
        if (!gplanResults || gplanResults.length === 0) {
          this.isGPlanGmonChartEmpty = true;

          return;
        }
        const gPlanOutputData = JSON.parse(gplanResults);

        const xAxisCategories: Map<string, string> = new Map<string, string>();
        const tooltipV = Config.getChartTooltip("V");
        const series: Array<Series> = new Array<Series>();

        const mvDataPlan: Array<number> = new Array<number>();
        gPlanOutputData.voltageResult.average.forEach((value, index) => {
          const timestamp = value.timestamp;
          // console.log("timestamp2: " + timestamp)
          xAxisCategories.set(timestamp, timestamp);
          let valueFloat = null;
          if (value != null && value.value != null)
            valueFloat = parseFloat(NumberUtils.format1(value.value, 2));
          mvDataPlan.push(valueFloat);
        });
        const mediumSeriesPlan: Series = new Series(
          this.labelWorstCaseVoltage,
          mvDataPlan
        );
        mediumSeriesPlan.tooltip = tooltipV;
        series.push(mediumSeriesPlan);

        this.applicationService
          .getGmonDataPlanning(this.selectedScenario.id, this.gridElementId)
          .subscribe((gmonResults: string) => {
            console.log("gmon_results: " + gmonResults)
            if (!gmonResults || gmonResults.length == 0) {
              // this.isGPlanGmonChartEmpty = true;
              // return;
              xAxisCategories.forEach((key: string) => {
                (this.gplanGmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories!.push(key);
              });
              this.gplanGmonTimeViewOptions.series = JSON.parse(
                JSON.stringify(series)
              );
              // console.log(JSON.stringify(this.gmonTimeViewOptions));
              this.gplanGmonTimeViewOptions.yAxis[0].plotLines[0].value =
                gPlanOutputData.voltageResult.upperViolationLimit;
              this.gplanGmonTimeViewOptions.yAxis[0].plotLines[1].value =
                gPlanOutputData.voltageResult.lowerViolationLimit;

              if (this.gplanGmonTimeViewChart) {
                this.gplanGmonTimeViewChart.options =
                  this.gplanGmonTimeViewOptions;
              }

            } else {
              const gMonOutputData = JSON.parse(gmonResults);

              const mvData: Array<number> = new Array<number>();
              gMonOutputData.voltageResult.average.forEach((value) => {
                const timestamp = value.timestamp;
                xAxisCategories.set(timestamp, timestamp);
                let valueFloat = null;

                if (value != null && value.value != null)
                  valueFloat = parseFloat(NumberUtils.format1(value.value, 2));

                mvData.push(valueFloat);
                // allValues.push(valueFloat);
              });
              const mediumSeries: Series = new Series(this.labelVoltage, mvData);
              mediumSeries.tooltip = tooltipV;
              series.push(mediumSeries);

              // console.log(JSON.stringify(series));

              xAxisCategories.forEach((key: string) => {
                (this.gplanGmonTimeViewOptions.xAxis as Highcharts.XAxisOptions).categories!.push(key);
              });

              this.gplanGmonTimeViewOptions.yAxis[0].plotLines[0].value =
                gPlanOutputData.voltageResult.upperViolationLimit;
              this.gplanGmonTimeViewOptions.yAxis[0].plotLines[1].value =
                gPlanOutputData.voltageResult.lowerViolationLimit;

              this.gplanGmonTimeViewOptions.series = JSON.parse(
                JSON.stringify(series)
              );
              // console.log(JSON.stringify(this.gmonTimeViewOptions));
              console.log("Gplan chart: " + this.gplanGmonTimeViewChart);
              if (this.gplanGmonTimeViewChart) {
                this.gplanGmonTimeViewChart.options =
                  this.gplanGmonTimeViewOptions;
                console.log(
                  "gplanGmonTimeViewChart has type :" +
                  typeof this.gplanGmonTimeViewChart
                );
              }

              // console.log("Here is the length of the series :", this.gplanGmonTimeViewOptions.series);
              // console.log("Here are the xAxis categories: ", this.gplanGmonTimeViewOptions.xAxis);
            }
            this.updateGplanGmonTimeViewChartFlag = true;
          });
      },
      (error) => {
        console.error(error);

      }
    );


    clearInterval(this.intervalVariable);
  }

  loadFrequencyDetailsView() {
    setTimeout(() => {

    });
    if (this.gMonOutputData) {
      this.frequencyDetailsView(this.gMonOutputData);
    } else {
      // const id = this.gridElementService.resetTrafoId(this.gridElementId);
      this.applicationService.getGmonTimeView(this.gridElementId).subscribe(
        (gmonResults: string) => {
          if (!gmonResults || gmonResults.length === 0) {
            this.isFrequencyTimeChartEmpty = true;
            // this.showFrequency = false;

            return;
          }
          const gMonOutputData = JSON.parse(gmonResults);
          // console.log("gMonOutputData : " + JSON.stringify(gMonOutputData));
          this.frequencyDetailsView(gMonOutputData);
        },
        (error) => {
          this.isFrequencyTimeChartEmpty = true;
          console.error(error);

        }
      );
    }

    clearInterval(this.intervalVariable);
  }

  private frequencyDetailsView(gMonOutputData: any) {
    if (gMonOutputData.frequencyResult == null) {
      this.isFrequencyTimeChartEmpty = true;
      // this.showFrequency = false;

      return;
    }
    const xAxisCategories: Map<string, string> = new Map<string, string>();
    const series: Array<Series> = new Array<Series>();
    const tooltipHz = Config.getChartTooltip("Hz");
    const mvData: Array<number> = new Array<number>();
    gMonOutputData.frequencyResult.average.forEach((value) => {
      const timestamp = value.timestamp;
      xAxisCategories.set(timestamp, timestamp);
      let valueTemp = null;
      if (value.value != null) {
        valueTemp = parseFloat(NumberUtils.format1(value.value, 2));
      }

      mvData.push(valueTemp);
    });
    const mediumSeries: Series = new Series(this.labelFrequency, mvData);
    mediumSeries.tooltip = tooltipHz;
    series.push(mediumSeries);

    // console.log(JSON.stringify(series));

    xAxisCategories.forEach((key: string) => {
      this.frequencyDetailsViewOptions.xAxis[0].categories.push(key);
    });

    this.frequencyDetailsViewOptions.yAxis[0].plotLines[0].value =
      gMonOutputData.frequencyResult.upperViolationLimit;
    this.frequencyDetailsViewOptions.yAxis[0].plotLines[1].value =
      gMonOutputData.frequencyResult.lowerViolationLimit;
    // this.frequencyTimeViewOptions.yAxis[0].average = gMonOutputData.frequencyResult.avgAverage;

    this.frequencyDetailsViewOptions.series = JSON.parse(
      JSON.stringify(series)
    );
    // console.log(JSON.stringify(this.frequencyTimeViewOptions));
    if (this.frequencyDetailsViewChart) {
      this.frequencyDetailsViewChart.options =
        this.frequencyDetailsViewOptions;
    }

  }

  loadFrequencySummaryView() {
    setTimeout(() => {

    });
    if (this.gMonOutputData) {
      this.frequencySummaryView(this.gMonOutputData);
    } else {
      // const id = this.gridElementService.resetTrafoId(this.gridElementId);
      this.applicationService.getGmonTimeView(this.gridElementId).subscribe(
        (gmonResults: string) => {
          if (!gmonResults || gmonResults.length === 0) {
            this.isFrequencyTimeChartEmpty = true;
            // this.showFrequency = false;

            return;
          }
          const gMonOutputData = JSON.parse(gmonResults);
          // console.log('gMonOutputData : ' + JSON.stringify(gMonOutputData));
          this.frequencySummaryView(gMonOutputData);
        },
        (error) => {
          this.isFrequencyTimeChartEmpty = true;
          // alert(error);
          console.error(error);

        });
    }


    clearInterval(this.intervalVariable);
  }

  private frequencySummaryView(gMonOutputData: any) {
    if (gMonOutputData.frequencyResult == null) {
      this.isFrequencyTimeChartEmpty = true;
      //  this.showFrequency = false;

      return;
    }

    const arrDates: Array<string> = new Array<string>();
    gMonOutputData.frequencyResult.average.forEach((value) => {
      if (value.timestamp) {
        arrDates.push(value.timestamp);
      }
    });
    // console.log(arrDates);
    const arrDatesSort = arrDates.sort(
      (a, b) => Date.parse(a) - Date.parse(b)
    );
    const minDate = arrDatesSort[0];
    const maxDate = arrDatesSort[arrDates.length - 1];
    if (minDate || maxDate) {
      this.frequencySummaryViewOptions.subtitle.text =
        DateUtils.stringUTCDateToLocalDate(minDate) + "  -  " + DateUtils.stringUTCDateToLocalDate(maxDate);
      // this.frequencySummaryViewOptions.xAxis.title.text = minDate + "  -  " + maxDate;
    }

    const tooltipHz: any = Config.getChartTooltip("Hz");

    const avgSeries: Series = new Series(this.labelAverage, [
      gMonOutputData.frequencyResult.avgAverage,
    ]);
    avgSeries.tooltip = tooltipHz;

    const minSeries: Series = new Series(this.labelMinimum, [
      gMonOutputData.frequencyResult.minMeasurement,
    ]);
    minSeries.tooltip = tooltipHz;

    const maxSeries: Series = new Series(this.labelMaximum, [
      gMonOutputData.frequencyResult.maxMeasurement,
    ]);
    maxSeries.tooltip = tooltipHz;

    const numberOfViolationsSeries: Series = new Series(this.labelViolations, [
      gMonOutputData.frequencyResult.numberOfViolations,
    ]);
    numberOfViolationsSeries.color = "red";
    numberOfViolationsSeries.tooltip = Config.getChartTooltip("");

    // const xAxisCategories: Array<string> = new Array<string>();
    const series: Array<Series> = new Array<Series>();

    numberOfViolationsSeries.yAxis = 1;

    series.push(minSeries);
    series.push(maxSeries);
    series.push(avgSeries);
    series.push(numberOfViolationsSeries);

    // console.log("series: " + JSON.stringify(series));

    this.frequencySummaryViewOptions.yAxis[0].plotLines[0].value =
      gMonOutputData.frequencyResult.upperViolationLimit;
    this.frequencySummaryViewOptions.yAxis[0].plotLines[1].value =
      gMonOutputData.frequencyResult.lowerViolationLimit;
    // this.frequencySummaryViewOptions.xAxis.categories = xAxisCategories;
    this.frequencySummaryViewOptions.series = JSON.parse(
      JSON.stringify(series)
    );
    if (this.frequencySummaryViewChart) {
      this.frequencySummaryViewChart.options =
        this.frequencySummaryViewOptions;
    }

  }

  getGridNodeTabColor() {
    const gridColorAppsJson: string = localStorage.getItem("gridColorApps");
    if (gridColorAppsJson) {
      const gridColorApps: Array<GridColor> = JSON.parse(gridColorAppsJson);
      let gridColor;
      for (const gc of gridColorApps) {
        if (gc.gridElementId == this.gridElementId) {
          gridColor = new GridColor(+this.gridElementId);
          gridColor.voltage = gc.voltage;
          gridColor.voltageGP = gc.voltageGP;
          gridColor.frequency = gc.frequency;
          gridColor.la = gc.la;
          gridColor.laGP = gc.laGP;
          gridColor.rpa = gc.rpa;

          console.log("voltage: ", gridColor.voltage, "voltageGP: ", gridColor.voltageGP, "frequency: ", gridColor.frequency)
          break;
        }
      }
      this.setColorParameter(gridColor);
    }
  }

  private setColorParameter(gridColor: GridColor) {
    this.initDataAvailableParameters();

    //for Node Voltage tab
    if (this.gmonAvailable) {
      this.isDangerVoltage = false;
      this.isAttentionVoltage = false;
      // console.log('gridColor:  ' + JSON.stringify(gridColor));
      if (gridColor.voltage === Condition.ATTENTION) {
        this.isAttentionVoltage = true;
      } else if (gridColor.voltage === Condition.PROBLEM) {
        this.isDangerVoltage = true;
      }
      console.log("gridColor.voltage: " + gridColor.voltage)
    }


    //for Plan Voltage tab
    if (this.gplanAvailable) {
      this.isDangerVoltageGP = false;
      this.isAttentionVoltageGP = false;
      // console.log('gridColor:  ' + JSON.stringify(gridColor));
      if (gridColor.voltageGP === Condition.ATTENTION) {
        this.isAttentionVoltageGP = true;
      } else if (gridColor.voltageGP === Condition.PROBLEM) {
        this.isDangerVoltageGP = true;
      }
      console.log("gridColor.voltageGP: " + gridColor.voltageGP)
    }

    // for "Frequency Detailed" and "Frequency Summary" tabs
    if (this.frequencyDataAvailable) {
      this.isDangerFrequency = false;
      this.isAttentionFrequency = false;
      if (gridColor.frequency === Condition.ATTENTION) {
        this.isAttentionFrequency = true;
      } else if (gridColor.frequency === Condition.PROBLEM) {
        this.isDangerFrequency = true;
      }
      console.log("gridColor.frequency: " + gridColor.frequency)
    }

    //for "Node Loading" tab
    if (this.laDataAvailable) {
      this.isDangerLA = false;
      this.isAttentionLA = false;
      console.log("gridColor.la: " + gridColor.la);
      if (gridColor.la === Condition.ATTENTION) {
        this.isAttentionLA = true;
      } else if (gridColor.la === Condition.PROBLEM) {
        this.isDangerLA = true;
      }
      console.log("gridColor.la: " + gridColor.la)

    }

    //for "Plan Loading" tab
    if (this.gplanAvailable) {
      this.isDangerLAGP = false;
      this.isAttentionLAGP = false;
      console.log("gridColor.laGP: " + gridColor.laGP);
      if (gridColor.laGP === Condition.ATTENTION) {
        this.isAttentionLAGP = true;
      } else if (gridColor.laGP === Condition.PROBLEM) {
        this.isDangerLAGP = true;
      }
      console.log("gridColor.laGP: " + gridColor.laGP)

    }

    // "Reactive Power Analysis" and "Reactive Power Violation" tabs
    if (this.rpaDataAvailable) {
      this.isDangerRPA = false;
      this.isAttentionRPA = false;
      if (gridColor.rpa === Condition.ATTENTION) {
        this.isAttentionRPA = true;
      } else if (gridColor.rpa === Condition.PROBLEM) {
        this.isDangerRPA = true;
      }
      console.log("gridColor.rpa: " + gridColor.rpa)

    }
  }

  loadThdMonitoringResults() {
    console.log("THD Results received : ");

    let gridElementIds: Array<number> = new Array<number>();
    gridElementIds.push(this.gridElementId);
    //NEed to change passing argument here to gridElementId?
    this.thdMonitoringService.getThdMonitoringResults(gridElementIds).subscribe((thdMonitoringResultsArray: string) => {
      // console.log("This is my response >> ", JSON.parse(thdMonitoringResultsArray))
      // const thdMonitoringOutputData = JSON.parse(thdMonitoringResultsArray);
      if (!thdMonitoringResultsArray || thdMonitoringResultsArray.length === 0) {
        console.log("There are no results!");
        return;
      }

      const thdMonitoringOutputData = JSON.parse(thdMonitoringResultsArray);
      console.log("THD Monitroing results : ", JSON.stringify(thdMonitoringOutputData));
      this.thdMonitoringResultsView(thdMonitoringOutputData);

    }, (error) => {
      console.error(error);
    })
  }

  thdMonitoringResultsView(thdMonitoringOutputData: any) {
    if (thdMonitoringOutputData == null) {
      return;
    }

    const tooltipV = Config.getChartTooltip("%");
    const xAxisCategories: Map<string, string> = new Map<string, string>();
    const series: Array<Series> = new Array<Series>();

    const thdMonitoringValues: Array<number> = new Array<number>();

    if (thdMonitoringOutputData.max) {
      thdMonitoringOutputData.max.forEach((measurement) => {
        const timestamp = measurement.timestamp;
        // console.log("Here is just a timestamp : ", timestamp)
        xAxisCategories.set(timestamp, timestamp);

        let valueTemp = null;
        if (measurement.value != null) {
          valueTemp = parseFloat(NumberUtils.format1(measurement.value, 2));
        }

        thdMonitoringValues.push(valueTemp);
        // console.log("here is hte array of thd measurements : ", thdMonitoringValues)
      });
    }

    if (thdMonitoringValues.length > 0) {
      const thdSeries: Series = new Series(this.thdMonitoringChartSeriesLegend, thdMonitoringValues);
      thdSeries.tooltip = tooltipV;
      thdSeries.color = "#C00800"
      series.push(thdSeries);
    }

    xAxisCategories.forEach((key: string) => {
      this.thdMonitoringOptions.xAxis[0].categories.push(key);
    })

    this.thdMonitoringOptions.series = JSON.parse(JSON.stringify(series));

    if (this.thdMonitoringResultsChart) {
      this.thdMonitoringResultsChart.options = this.thdMonitoringOptions;
    }
  }

  private initDataAvailableParameters() {
    this.gmonDataAvailable = this.gMonService.areDataAvailable("areVoltageDataAvailable");
    this.frequencyDataAvailable = this.gMonService.areDataAvailable("areFrequencyDataAvailable");
    this.laDataAvailable = this.laService.areLADataAvailable();
    this.rpaDataAvailable = this.reactivePowerAnalysisService.areRPADataAvailable();
    this.gplanDataAvailable = this.gPlanService.areGplanDataAvailable();
  }

  private initGmonData() {
    this.applicationService.getGmonTimeView(this.gridElementId).subscribe(
      (gmonResults: string) => {
        if (!gmonResults || gmonResults.length === 0) {
          this.showFrequency = false;
          this.showGmon = false;
          return;
        }
        this.gMonOutputData = JSON.parse(gmonResults);
        this.gmonDataAvailable = true;
        // localStorage.setItem("gMonOutputData", JSON.stringify(this.gMonOutputData));
        console.log('gMonOutputData : ' + JSON.stringify(this.gMonOutputData));
//        this.voltageTimeView(JSON.parse(gmonResults));
        if (this.gMonOutputData.frequencyResult) {
          this.showFrequency = true;
        } else {
          this.showFrequency = false;
        }
      },
      (error) => {
        this.isFrequencyTimeChartEmpty = true;
        console.error(error);
      });
  }

  isLMRunning(): boolean {
    let currentTopology = JSON.parse(localStorage.getItem("currentTopology"));
    return this.lmService.isLMRunning(currentTopology.topologyId);
  }


  ngOnDestroy() {
    this.timestampArray.length = 0;
    clearInterval(this.intervalVariable);
  }

  copyToClipboard() {
    const textToCopy = `${this.gridElementName}`;
    const success = this.copyTextToClipboard(textToCopy);
  }

  // Method to copy text to clipboard
  copyTextToClipboard(text: string): boolean {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    const successful = document.execCommand('copy');
    document.body.removeChild(textarea);
    return successful;
  }

  jumpToTopology(){
    let currentTopology = JSON.parse(localStorage.getItem("currentTopology"));
    this.activeModal.close();
    let prop = { "param": this.jumpTopology, "param2": currentTopology.topologyId }
    this.communicationService.triggerMethod(prop);
  }

  onReactivePowerAnalysisPointClicked(point: any){
    //http://localhost:7777/icg/v1/rest/measurement/getConnectedNodesActiveAndReactivePower
    // /LandauTop/2025-08-05T11:45:00/2025-08-05T12:00:00


    console.log('Point clicked: ', {
      x: point.x,
      y: point.y,
      category: point.category
    });
    // console.log("Here is the point ", point);
    const currentTopology = JSON.parse(localStorage.getItem("currentTopology"));
    const endTimestamp = DateUtils.stringDateToIso8601Type1(point.category);
    const startTimestamp = DateUtils
      .stringDateToIso8601Type1(DateUtils
      .substract15Minutes(DateUtils
      .stringDateToIso8601Type1(point.category)));
    // console.log("HEre is converted value : ", startTimestamp);
    // console.log("HEre is added 15 minutes version: ", endTimestamp);
    // console.log("here is currrent topology: ", currentTopology);
    this.timestampTitleForConnectedNodesActiveAndReactivePowerCharts = DateUtils.iso8601ToStringDate(startTimestamp) + " - " + DateUtils.iso8601ToStringDate2(endTimestamp);

    this.reactivePowerAnalysisService
      .getConnectedNodesActiveAndReactivePower(currentTopology.topologyId, startTimestamp, startTimestamp)
      .subscribe((response: Array<RpaConnectedNodes>) => {
      // console.log("Here is the response: ", response);
      this.connectedNodesActiveAndReactivePower = response;
      this.populateConnectedNodesReactivePowerChart(response);
      // this.populateConnectedNodesActivePowerChart(response);
      this.updateConnectedNodesActivePowerTabFlag = true;
      this.updateConnectedNodesReactivePowerTabFlag = true;
      // console.log("here is the flag update: ", this.updateConnectedNodesActivePowerChartFlag);
    })
  }

  private populateConnectedNodesReactivePowerChart(connectedNodesActiveAndReactivePower: Array<RpaConnectedNodes>){
    this.reactivePowerUnitForConnectedNodesReactivePowerChart = connectedNodesActiveAndReactivePower.length > 0 ? connectedNodesActiveAndReactivePower[0].reactiveUnit : "";
    if(connectedNodesActiveAndReactivePower.length > 0){
      const categories: string[] = [];
      const reactivePowerData: number[] = [];
      const tooltipReactivePower = Config.getChartTooltip(connectedNodesActiveAndReactivePower[0].reactiveUnit);

      connectedNodesActiveAndReactivePower.forEach((item) => {
        categories.push(item.dsoInternalId);
        reactivePowerData.push(item.reactivePower);
      });

      const reactivePowerSeries: Series = new Series("Reactive Power", reactivePowerData);

      reactivePowerSeries.tooltip = tooltipReactivePower;
      reactivePowerSeries.color = "#0569C3";     //dark blue

      this.connectedNodesReactivePowerOptions = {
        ...this.connectedNodesReactivePowerOptions,
        // title: {
        //   ...this.connectedNodesReactivePowerOptions.title,
        //   text: this.timestampTitleForConnectedNodesActiveAndReactivePowerCharts
        // },
        subtitle: {
          ...this.connectedNodesReactivePowerOptions.subtitle,
          text: this.timestampTitleForConnectedNodesActiveAndReactivePowerCharts
        },
        xAxis: {
          ...(this.connectedNodesReactivePowerOptions.xAxis as Highcharts.XAxisOptions),
          categories: categories
        },
        yAxis: {
          // ...(this.connectedNodesReactivePowerOptions.yAxis as Highcharts.YAxisOptions),
          title: {
            text: this.reactivePowerUnitForConnectedNodesReactivePowerChart
          }
        },
        series: [{
          type: 'column',
          name: 'Reactive Power',
          data: reactivePowerData,
          tooltip: tooltipReactivePower,
          color: "#0569C3"
        }]
      };

      // console.log("Here are the primal series: ", reactivePowerSeries);
      // console.log("Here are the series: ", this.connectedNodesReactivePowerOptions.series);

      if(this.connectedNodesReactivePowerChart){
        this.connectedNodesReactivePowerChart.options = this.connectedNodesReactivePowerOptions;
      }
    }
  }

  private populateConnectedNodesActivePowerChart(connectedNodesActiveAndReactivePower: Array<RpaConnectedNodes>){
    this.activePowerUnitForConnectedNodesActivePowerChart = connectedNodesActiveAndReactivePower.length > 0 ? connectedNodesActiveAndReactivePower[0].activeUnit : "";
    if(connectedNodesActiveAndReactivePower.length > 0){
      const categories: string[] = [];
      const activePowerData: number[] = [];
      const tooltipActivePower = Config.getChartTooltip(connectedNodesActiveAndReactivePower[0].activeUnit);

      connectedNodesActiveAndReactivePower.forEach((item) => {
        categories.push(item.dsoInternalId);
        activePowerData.push(item.activePower);
      });

      const activePowerSeries: Series = new Series("Active Power", activePowerData);

      activePowerSeries.tooltip = tooltipActivePower;
      activePowerSeries.color = "#0569C3";     //dark blue

      this.connectedNodesActivePowerOptions = {
        ...this.connectedNodesActivePowerOptions,
        // title: {
        //   ...this.connectedNodesActivePowerOptions.title,
        //   text: this.timestampTitleForConnectedNodesActiveAndReactivePowerCharts
        // },
        subtitle: {
          ...this.connectedNodesActivePowerOptions.subtitle,
          text: this.timestampTitleForConnectedNodesActiveAndReactivePowerCharts
        },
        xAxis: {
          ...(this.connectedNodesActivePowerOptions.xAxis as Highcharts.XAxisOptions),
          categories: categories
        },
        yAxis: {
          // ...(this.connectedNodesActivePowerOptions.yAxis as Highcharts.YAxisOptions),
          title: {
            text: this.activePowerUnitForConnectedNodesActivePowerChart
          }
        },
        series: [{
          type: 'column',
          name: 'Active Power',
          data: activePowerData,
          tooltip: tooltipActivePower,
          color: "#0569C3"
        }]
      };

      // (this.connectedNodesActivePowerOptions.xAxis as Highcharts.XAxisOptions).categories = categories;
      // this.connectedNodesActivePowerOptions.series = JSON.parse(JSON.stringify(activePowerSeries));
      // console.log("Here are the primal series: ", activePowerSeries);
      // console.log("Here are the series: ", this.connectedNodesActivePowerOptions.series);

      if(this.connectedNodesActivePowerChart){
        this.connectedNodesActivePowerChart.options = this.connectedNodesActivePowerOptions;
      }

      this.updateConnectedNodesActivePowerChartFlag = true;
      // this.activeTab = "connected-nodes-active-power";
      // setTimeout(() => {
      //   if (this.connectedNodesActivePowerChart) {
      //     this.connectedNodesActivePowerChart.updateOrCreateChart();
      //   }
      // }, 0);

      // console.log("Here is the chart: ", this.connectedNodesActivePowerChart);
      // console.log("Here is the options: ", this.connectedNodesActivePowerOptions);

    }
  }

  getInternalDsoIdOfTopologyToJump(): string{
    if(!this.jumpTopology){
      return;
    }

    const listOfTopologies: TopologyList = JSON.parse(localStorage.getItem('topologies'));

    this.topologyToJumpDisplayName;

    listOfTopologies.topologiesWithRoots.forEach((topology: TopologyWithRoot) => {
      if(topology.TopologyId == this.jumpTopology){
        this.topologyToJumpDisplayName = topology.displayName;
      }
    });
  }

}
